(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// CONCATENATED MODULE: ./moduls/utils.js
var selectViewFunction = function selectViewFunction(data, selectionRules) {
  // console.log(`selectViewFunction 777-1`);
  // console.log(data);
  // console.log(selectionRules);
  for (var _iterator = selectionRules, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var item = _ref;

    for (var _iterator2 = item, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var rule = _ref2;

      if (!Array.isArray(rule)) {
        return rule;
      } else if (!(rule[0] in data) || data[rule[0]] !== rule[1]) {
        break;
      }
    }
  }
};

var createRandomArray = function createRandomArray(length) {
  // console.log(`createRandomArray 777-2`);
  var numbersArray = [];
  for (var i = 1; i <= length; i++) {
    numbersArray.push(i);
  }

  var currentIndex = length;

  while (0 !== currentIndex) {
    var randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    var temporaryValue = numbersArray[currentIndex];
    numbersArray[currentIndex] = numbersArray[randomIndex];
    numbersArray[randomIndex] = temporaryValue;
  }

  return numbersArray;
};

var createOrder = function createOrder(mockObject, questionsNumber, orderArray) {
  // console.log(`createOrder 777-3`);
  var last = orderArray[questionsNumber - 1];

  orderArray.forEach(function (elem, i) {

    for (var key in mockObject) {

      if (mockObject[key].next === 'win') {
        if (parseInt(key) === elem && i < questionsNumber && parseInt(key) !== last) {
          mockObject[key].next = String(orderArray[i + 1]);
        }

        if (parseInt(key) === last) {
          mockObject[key].next = 'finish';
        }
      }
    }
  });
};
// CONCATENATED MODULE: ./data/get-mock-data.js


var QUESTIONS_NUMBER = 6;

var questionsArray = createRandomArray(QUESTIONS_NUMBER);

var GAME_1 = [{
  id: 1,
  start: '1',
  steps: {
    'start': {
      type: 'comment',
      imageSrc: './assets/photo/start.jpg',
      imageAuthor: '',
      comment: '<div>\n        <h2>\u041A\u0410\u041A \u041F\u041E\u041B\u0423\u0427\u0418\u0422\u042C \u041F\u041E\u0414\u0414\u0415\u0420\u0416\u041A\u0423 \u041E\u0422 \u0413\u041E\u0421\u0423\u0414\u0410\u0420\u0421\u0422\u0412\u0410</h2>\n        <p>\u041F\u043E\u043C\u043E\u0433\u0438 \u0440\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0438\u043C \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0438 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u044F, \u043B\u044C\u0433\u043E\u0442\u044B \u0438 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u0424\u0421\u0421 \u0420\u0424</p>\n        <p>\u041F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C \u0432\u0430\u0448\u0435\u043C\u0443 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u044E, \u0443\u0432\u0430\u0436\u0430\u0435\u043C\u044B\u0435 \u0447\u0438\u0442\u0430\u0442\u0435\u043B\u0438, \u0438\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439 \u043E\u043D\u043B\u0430\u0439\u043D-\u0442\u044C\u044E\u0442\u043E\u0440\u0438\u0430\u043B \u2013 \u0443\u0447\u0435\u0431\u043D\u043E\u0435 \u043F\u043E\u0441\u043E\u0431\u0438\u0435, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043F\u043E\u0434\u0441\u043A\u0430\u0436\u0435\u0442, \u043A\u0430\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u0443\u044E \u043F\u043E\u043C\u043E\u0449\u044C, \u0433\u0440\u0430\u043C\u043E\u0442\u043D\u043E \u0438 \u044D\u0444\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u043E \u0440\u0435\u0430\u043B\u0438\u0437\u043E\u0432\u0430\u0442\u044C \u0441\u0432\u043E\u0438 \u043F\u0440\u0430\u0432\u0430 \u0438 \u043B\u044C\u0433\u043E\u0442\u044B.</p>\n        <p>\u0414\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0430\u0435\u043C \u0432\u0430\u0441 \u043F\u0440\u043E\u0439\u0442\u0438 6 \u0443\u0440\u043E\u043A\u043E\u0432.</p>\n      </div>',
      description: '\n        <style>.question-counter{display:none}</style>\n        <p>\u0420\u043E\u0441\u0441\u0438\u044F \u2013 \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0438 \u043F\u043E\u043B\u043D\u0430\u044F \u0447\u0443\u0434\u0435\u0441, \u0441\u043E\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044B\u0445 \u043F\u0440\u0438\u0440\u043E\u0434\u043E\u0439, \u0441\u0442\u0440\u0430\u043D\u0430. \u0412\u044B\u0441\u043E\u043A\u0438\u0435 \u0433\u043E\u0440\u044B \u041A\u0430\u0432\u043A\u0430\u0437\u0430, \u0441\u043D\u0435\u0436\u043D\u044B\u0435 \u043F\u0440\u043E\u0441\u0442\u043E\u0440\u044B \u0442\u0443\u043D\u0434\u0440\u044B \u0438 \u0436\u0430\u0440\u043A\u0438\u0439 \u043F\u0435\u0441\u043E\u043A \u0431\u0435\u0440\u0435\u0433\u043E\u0432 \u043C\u043E\u0440\u044F \u2013 \u0432\u0441\u0435 \u044D\u0442\u043E \u043D\u0430\u0448\u0435 \u0434\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435. \u0421 \u043A\u0430\u0436\u0434\u044B\u043C \u0433\u043E\u0434\u043E\u043C \u043C\u0435\u0441\u0442, \u0433\u0434\u0435 \u0435\u0449\u0435 \u043D\u0435 \u0441\u0442\u0443\u043F\u0430\u043B\u0430 \u043D\u043E\u0433\u0430 \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430, \u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0441\u044F \u0432\u0441\u0435 \u043C\u0435\u043D\u044C\u0448\u0435, \u043D\u043E \u0432 \u0420\u043E\u0441\u0441\u0438\u0438 \u0435\u0441\u0442\u044C \u0443\u0433\u043E\u043B\u043A\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438 \u0441\u0432\u043E\u0435 \u0435\u0441\u0442\u0435\u0441\u0442\u0432\u043E, \u0437\u0430\u043F\u043E\u0432\u0435\u0434\u043D\u044B\u0435 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438, \u0433\u0434\u0435 \u0442\u0449\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u043E\u0431\u0435\u0440\u0435\u0433\u0430\u0435\u0442\u0441\u044F \u0432\u0441\u0435 \u0431\u0443\u0439\u0441\u0442\u0432\u043E \u0444\u043B\u043E\u0440\u044B \u0438 \u0444\u0430\u0443\u043D\u044B \u0434\u043B\u044F \u0431\u0443\u0434\u0443\u0449\u0438\u0445 \u043F\u043E\u043A\u043E\u043B\u0435\u043D\u0438\u0439. \u041D\u0430 \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u0435 \u044D\u0442\u0438\u0445 \u043F\u0440\u0435\u043A\u0440\u0430\u0441\u043D\u044B\u0445 \u043C\u0435\u0441\u0442 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043E\u0434\u0438\u043D \u0438\u0437 \u0432\u0430\u0436\u043D\u0435\u0439\u0448\u0438\u0445 \u0444\u0435\u0434\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u041C\u0438\u043D\u043F\u0440\u0438\u0440\u043E\u0434\u044B \xAB\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435 \u0431\u0438\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0440\u0430\u0437\u043D\u043E\u043E\u0431\u0440\u0430\u0437\u0438\u044F \u0438 \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u0435 \u044D\u043A\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u0442\u0443\u0440\u0438\u0437\u043C\u0430\xBB. \u0410 \u0432\u044B \u0437\u043D\u0430\u0435\u0442\u0435 \u043E\u0431 \u044D\u0442\u0438\u0445 \u0437\u0430\u043F\u043E\u0432\u0435\u0434\u043D\u0438\u043A\u0430\u0445? \u0414\u0430\u0432\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u043C, \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u043B\u0438 \u0432\u044B \u0443\u0433\u0430\u0434\u0430\u0442\u044C, \u043F\u0440\u043E \u043A\u0430\u043A\u0443\u044E \u0441\u0442\u0440\u0430\u043D\u0443 \u0438\u0434\u0435\u0442 \u0440\u0435\u0447\u044C?</p>',
      specialClass: 'content__step_start',
      button: true,
      buttonText: 'Пройти 6 уроков',
      next: '1'
    },
    '1': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-1.jpg',
      imageAuthor: '',
      description: '<p>\u0422\u0435\u043F\u043B\u043E\u0435 \u043B\u0435\u0442\u043D\u0435\u0435 \u0443\u0442\u0440\u043E, \u0440\u043E\u0437\u043E\u0432\u043E \u0443\u043B\u044B\u0431\u0430\u044F\u0441\u044C, \u0432 \u043E\u043A\u043D\u043E \u0437\u0430\u0433\u043B\u044F\u0434\u044B\u0432\u0430\u0435\u0442 \u0441\u043E\u043B\u043D\u044B\u0448\u043A\u043E\u2026 \u0410 \u0432\u0430\u043C \u0445\u043E\u043B\u043E\u0434\u043D\u043E \u0438 \u0433\u0440\u0443\u0441\u0442\u043D\u043E, \u0438 \u0431\u043E\u043B\u0438\u0442 \u0433\u043E\u0440\u043B\u043E, \u0438 \u043D\u0430 \u0433\u0440\u0430\u0434\u0443\u0441\u043D\u0438\u043A\u0435 37,8. \u0412\u044B \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B\u0438 \u0432\u0440\u0430\u0447\u0443 \u0438 \u0440\u0430\u0441\u0441\u043A\u0430\u0437\u0430\u043B\u0438 \u043E \u0441\u0432\u043E\u0438\u0445 \u0441\u0438\u043C\u043F\u0442\u043E\u043C\u0430\u0445. \u0412\u0440\u0430\u0447 \u043F\u043E\u0441\u043E\u0432\u0435\u0442\u043E\u0432\u0430\u043B \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u043C\u044B\u0441\u043B\u0438 \u0438\u0434\u0442\u0438 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u2013 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0443 \u0432\u0430\u0441 \u0432\u0438\u0440\u0443\u0441\u043D\u0430\u044F \u0438\u043D\u0444\u0435\u043A\u0446\u0438\u044F. \u041E\u0445, \u0441\u0442\u043E\u043B\u044C\u043A\u043E \u0432\u0441\u0435\u0433\u043E \u043D\u0443\u0436\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C! \u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C \u0432 \u043E\u0444\u0438\u0441 \u0438 \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0434\u0438\u0442\u044C\u2026 \u0438 \u0434\u0430! \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0431\u043E\u043B\u044C\u043D\u0438\u0447\u043D\u044B\u0439. \u041A\u0430\u043A \u044D\u0442\u043E \u043B\u0443\u0447\u0448\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C?</p>',
      answers: [{
        title: 'Сделаю, как и раньше - врач выпишет больничный лист, получу его на руки. Потом при необходимости пойду в поликлинику на прием к доктору и продлю больничный или закрою.',
        next: '1a'
      }, {
        title: 'Ммм… Нет, позвоню-ка лучше соседке, ее муж работал раньше в частной клинике, наверное, сможет как-то помочь… Может, выпишет больничный, чтобы не бегать по поликлиникам и не сидеть в очереди.',
        next: '1b'
      }, {
        title: 'Оформлю электронный больничный.',
        next: '1c'
      }]
    },
    '1a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-1a.jpg',
      imageAuthor: '',
      comment: '<p>\u0422\u0435\u043F\u043B\u043E\u0435 \u043B\u0435\u0442\u043D\u0435\u0435 \u0443\u0442\u0440\u043E, \u0440\u043E\u0437\u043E\u0432\u043E \u0443\u043B\u044B\u0431\u0430\u044F\u0441\u044C, \u0432 \u043E\u043A\u043D\u043E \u0437\u0430\u0433\u043B\u044F\u0434\u044B\u0432\u0430\u0435\u0442 \u0441\u043E\u043B\u043D\u044B\u0448\u043A\u043E\u2026 \u0410 \u0432\u0430\u043C \u0445\u043E\u043B\u043E\u0434\u043D\u043E \u0438 \u0433\u0440\u0443\u0441\u0442\u043D\u043E, \u0438 \u0431\u043E\u043B\u0438\u0442 \u0433\u043E\u0440\u043B\u043E, \u0438 \u043D\u0430 \u0433\u0440\u0430\u0434\u0443\u0441\u043D\u0438\u043A\u0435 37,8. \u0412\u044B \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B\u0438 \u0432\u0440\u0430\u0447\u0443 \u0438 \u0440\u0430\u0441\u0441\u043A\u0430\u0437\u0430\u043B\u0438 \u043E \u0441\u0432\u043E\u0438\u0445 \u0441\u0438\u043C\u043F\u0442\u043E\u043C\u0430\u0445. \u0412\u0440\u0430\u0447 \u043F\u043E\u0441\u043E\u0432\u0435\u0442\u043E\u0432\u0430\u043B \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u043C\u044B\u0441\u043B\u0438 \u0438\u0434\u0442\u0438 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u2013 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0443 \u0432\u0430\u0441 \u0432\u0438\u0440\u0443\u0441\u043D\u0430\u044F \u0438\u043D\u0444\u0435\u043A\u0446\u0438\u044F. \u041E\u0445, \u0441\u0442\u043E\u043B\u044C\u043A\u043E \u0432\u0441\u0435\u0433\u043E \u043D\u0443\u0436\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C! \u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C \u0432 \u043E\u0444\u0438\u0441 \u0438 \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0434\u0438\u0442\u044C\u2026 \u0438 \u0434\u0430! \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0431\u043E\u043B\u044C\u043D\u0438\u0447\u043D\u044B\u0439. \u041A\u0430\u043A \u044D\u0442\u043E \u043B\u0443\u0447\u0448\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C?</p>',
      answerList: [['Сделаю, как и раньше - врач выпишет больничный лист, получу его на руки. Потом при необходимости пойду в поликлинику на прием к доктору и продлю больничный или закрою.', 'selected'], ['Ммм… Нет, позвоню-ка лучше соседке, ее муж работал раньше в частной клинике, наверное, сможет как-то помочь… Может, выпишет больничный, чтобы не бегать по поликлиникам и не сидеть в очереди.', false], ['Оформлю электронный больничный.', false]],
      description: '<p>\u041A\u043E\u043D\u0435\u0447\u043D\u043E, \u043C\u043E\u0436\u043D\u043E \u0438 \u0442\u0430\u043A. \u041D\u043E \u0431\u0443\u043C\u0430\u0436\u043D\u044B\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u043E \u043D\u0435\u043E\u0441\u0442\u043E\u0440\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u043E\u043C\u044F\u0442\u044C, \u043F\u043E\u0440\u0432\u0430\u0442\u044C, \u0447\u0435\u043C-\u0442\u043E \u0437\u0430\u043B\u0438\u0442\u044C, \u0434\u0430 \u0435\u0449\u0435 \u0441\u043B\u0443\u0447\u0430\u0439\u043D\u043E \u043F\u043E\u0442\u0435\u0440\u044F\u0442\u044C. \u0410 \u0435\u0441\u043B\u0438 \u0431\u0443\u043C\u0430\u0436\u043D\u044B\u0439 \u043B\u0438\u0441\u0442\u043E\u043A \u043D\u0435\u0442\u0440\u0443\u0434\u043E\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u0438 \u0437\u0430\u0442\u0435\u0440\u044F\u0435\u0442\u0441\u044F \u0443 \u043D\u0435\u0440\u0430\u0434\u0438\u0432\u043E\u0433\u043E \u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0430?</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      // next: '1'
      // next: 'finish',
      next: '1'
    },
    '1b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-1b.jpg',
      imageAuthor: '',
      comment: '<p>\u0422\u0435\u043F\u043B\u043E\u0435 \u043B\u0435\u0442\u043D\u0435\u0435 \u0443\u0442\u0440\u043E, \u0440\u043E\u0437\u043E\u0432\u043E \u0443\u043B\u044B\u0431\u0430\u044F\u0441\u044C, \u0432 \u043E\u043A\u043D\u043E \u0437\u0430\u0433\u043B\u044F\u0434\u044B\u0432\u0430\u0435\u0442 \u0441\u043E\u043B\u043D\u044B\u0448\u043A\u043E\u2026 \u0410 \u0432\u0430\u043C \u0445\u043E\u043B\u043E\u0434\u043D\u043E \u0438 \u0433\u0440\u0443\u0441\u0442\u043D\u043E, \u0438 \u0431\u043E\u043B\u0438\u0442 \u0433\u043E\u0440\u043B\u043E, \u0438 \u043D\u0430 \u0433\u0440\u0430\u0434\u0443\u0441\u043D\u0438\u043A\u0435 37,8. \u0412\u044B \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B\u0438 \u0432\u0440\u0430\u0447\u0443 \u0438 \u0440\u0430\u0441\u0441\u043A\u0430\u0437\u0430\u043B\u0438 \u043E \u0441\u0432\u043E\u0438\u0445 \u0441\u0438\u043C\u043F\u0442\u043E\u043C\u0430\u0445. \u0412\u0440\u0430\u0447 \u043F\u043E\u0441\u043E\u0432\u0435\u0442\u043E\u0432\u0430\u043B \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u043C\u044B\u0441\u043B\u0438 \u0438\u0434\u0442\u0438 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u2013 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0443 \u0432\u0430\u0441 \u0432\u0438\u0440\u0443\u0441\u043D\u0430\u044F \u0438\u043D\u0444\u0435\u043A\u0446\u0438\u044F. \u041E\u0445, \u0441\u0442\u043E\u043B\u044C\u043A\u043E \u0432\u0441\u0435\u0433\u043E \u043D\u0443\u0436\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C! \u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C \u0432 \u043E\u0444\u0438\u0441 \u0438 \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0434\u0438\u0442\u044C\u2026 \u0438 \u0434\u0430! \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0431\u043E\u043B\u044C\u043D\u0438\u0447\u043D\u044B\u0439. \u041A\u0430\u043A \u044D\u0442\u043E \u043B\u0443\u0447\u0448\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C?</p>',
      answerList: [['Сделаю, как и раньше - врач выпишет больничный лист, получу его на руки. Потом при необходимости пойду в поликлинику на прием к доктору и продлю больничный или закрою.', false], ['Ммм… Нет, позвоню-ка лучше соседке, ее муж работал раньше в частной клинике, наверное, сможет как-то помочь… Может, выпишет больничный, чтобы не бегать по поликлиникам и не сидеть в очереди.', 'selected'], ['Оформлю электронный больничный.', false]],
      description: '<p>\u041D\u0435 \u0441\u0442\u044B\u0434\u043D\u043E? \u0410 \u0432\u044B \u0437\u043D\u0430\u0435\u0442\u0435, \u0447\u0442\u043E \u043B\u044E\u0431\u0430\u044F \u043F\u043E\u0434\u0434\u0435\u043B\u043A\u0430 \u0431\u043E\u043B\u044C\u043D\u0438\u0447\u043D\u043E\u0433\u043E \u043B\u0438\u0441\u0442\u0430 \u043D\u0430\u043A\u0430\u0437\u0443\u0435\u043C\u0430?</p>\n      ',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '1'
    },
    '1c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-1c.jpg',
      imageAuthor: '',
      comment: '<p>\u0422\u0435\u043F\u043B\u043E\u0435 \u043B\u0435\u0442\u043D\u0435\u0435 \u0443\u0442\u0440\u043E, \u0440\u043E\u0437\u043E\u0432\u043E \u0443\u043B\u044B\u0431\u0430\u044F\u0441\u044C, \u0432 \u043E\u043A\u043D\u043E \u0437\u0430\u0433\u043B\u044F\u0434\u044B\u0432\u0430\u0435\u0442 \u0441\u043E\u043B\u043D\u044B\u0448\u043A\u043E\u2026 \u0410 \u0432\u0430\u043C \u0445\u043E\u043B\u043E\u0434\u043D\u043E \u0438 \u0433\u0440\u0443\u0441\u0442\u043D\u043E, \u0438 \u0431\u043E\u043B\u0438\u0442 \u0433\u043E\u0440\u043B\u043E, \u0438 \u043D\u0430 \u0433\u0440\u0430\u0434\u0443\u0441\u043D\u0438\u043A\u0435 37,8. \u0412\u044B \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u043B\u0438 \u0432\u0440\u0430\u0447\u0443 \u0438 \u0440\u0430\u0441\u0441\u043A\u0430\u0437\u0430\u043B\u0438 \u043E \u0441\u0432\u043E\u0438\u0445 \u0441\u0438\u043C\u043F\u0442\u043E\u043C\u0430\u0445. \u0412\u0440\u0430\u0447 \u043F\u043E\u0441\u043E\u0432\u0435\u0442\u043E\u0432\u0430\u043B \u043E\u0442\u043A\u0430\u0437\u0430\u0442\u044C\u0441\u044F \u043E\u0442 \u043C\u044B\u0441\u043B\u0438 \u0438\u0434\u0442\u0438 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u2013 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u0443 \u0432\u0430\u0441 \u0432\u0438\u0440\u0443\u0441\u043D\u0430\u044F \u0438\u043D\u0444\u0435\u043A\u0446\u0438\u044F. \u041E\u0445, \u0441\u0442\u043E\u043B\u044C\u043A\u043E \u0432\u0441\u0435\u0433\u043E \u043D\u0443\u0436\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C! \u041F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u044C \u0432 \u043E\u0444\u0438\u0441 \u0438 \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0434\u0438\u0442\u044C\u2026 \u0438 \u0434\u0430! \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0431\u043E\u043B\u044C\u043D\u0438\u0447\u043D\u044B\u0439. \u041A\u0430\u043A \u044D\u0442\u043E \u043B\u0443\u0447\u0448\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C?</p>',
      answerList: [['Сделаю, как и раньше - врач выпишет больничный лист, получу его на руки. Потом при необходимости пойду в поликлинику на прием к доктору и продлю больничный или закрою.', false], ['Ммм… Нет, позвоню-ка лучше соседке, ее муж работал раньше в частной клинике, наверное, сможет как-то помочь… Может, выпишет больничный, чтобы не бегать по поликлиникам и не сидеть в очереди.', false], ['Оформлю электронный больничный.', 'selected']],
      description: '<p>\u0425\u043E\u0440\u043E\u0448\u0435\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u0435! \u0421\u0435\u0433\u043E\u0434\u043D\u044F \u043A\u0430\u0436\u0434\u044B\u0439 \u0440\u0430\u0431\u043E\u0442\u0430\u044E\u0449\u0438\u0439 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0438\u043D \u043C\u043E\u0436\u0435\u0442 \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u043B\u0438\u0441\u0442\u043E\u043A \u043D\u0435\u0442\u0440\u0443\u0434\u043E\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u0438 \u0432 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u043C \u0432\u0438\u0434\u0435, \u043F\u0440\u0438\u0447\u0435\u043C \u0443\u0436\u0435 \u043F\u0440\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 \u043D\u0430 \u0440\u0430\u0431\u043E\u0442\u0443 \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u0442\u044C \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044E \u043E \u043F\u0440\u0435\u0434\u043F\u043E\u0447\u0442\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u043C \u0441\u043F\u043E\u0441\u043E\u0431\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0432\u044B\u043F\u043B\u0430\u0442 \u0438\u0437 \u0424\u043E\u043D\u0434\u0430 \u0441\u043E\u0446\u0441\u0442\u0440\u0430\u0445\u0430.</p>\n      ',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '2'
    },
    '2': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-2.jpg',
      imageAuthor: '',
      description: '<p>\u041C\u043E\u043B\u043E\u0434\u0430\u044F \u0441\u0435\u043C\u044C\u044F \u041F\u0435\u0448\u043A\u043E\u0432\u044B\u0445 \u2212 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u043D\u0438\u0436\u0435\u0433\u043E\u0440\u043E\u0434\u0441\u043A\u043E\u0439 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0444\u0438\u0440\u043C\u044B \u2212 \u0433\u043E\u0442\u043E\u0432\u0438\u0442\u0441\u044F \u043A \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E. \u0420\u0430\u0434\u043E\u0441\u0442\u043D\u043E\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0435 \u0435\u0449\u0435 \u0432\u043F\u0435\u0440\u0435\u0434\u0438, \u0438 \u0431\u0443\u0434\u0443\u0449\u0430\u044F \u043C\u0430\u043C\u0430 \u0443\u0436\u0435 \u0441\u0435\u0439\u0447\u0430\u0441, \u043D\u0430 \u0440\u0430\u043D\u043D\u0435\u043C \u0441\u0440\u043E\u043A\u0435 \u0431\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0441\u0442\u0438, \u0432\u0441\u0442\u0430\u043B\u0430 \u043D\u0430 \u0443\u0447\u0435\u0442 \u0432 \u0436\u0435\u043D\u0441\u043A\u0443\u044E \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E. \u041D\u043E \u043A\u043E\u0440\u043E\u043D\u0430\u043A\u0440\u0438\u0437\u0438\u0441 \u0437\u0430\u043C\u0435\u0442\u043D\u043E \u043F\u043E\u0448\u0430\u0442\u043D\u0443\u043B \u0432\u0441\u0435 \u043F\u043B\u0430\u043D\u044B \u2013 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0441\u043E\u043A\u0440\u0430\u0442\u0438\u043B\u0430 \u0440\u044F\u0434 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0438 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E \u043F\u0435\u0440\u0435\u0448\u043B\u0430 \u043D\u0430 \u0434\u0438\u0441\u0442\u0430\u043D\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0444\u043E\u0440\u043C\u0443 \u0440\u0430\u0431\u043E\u0442\u044B, \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u044B \u0443\u043C\u0435\u043D\u044C\u0448\u0438\u043B\u0438\u0441\u044C. \u041F\u0435\u0448\u043A\u043E\u0432\u044B \xAB\u0441\u0430\u043C\u043E\u0438\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043B\u0438\u0441\u044C\xBB \u0437\u0430 \u0433\u043E\u0440\u043E\u0434\u043E\u043C \u0438 \u0437\u0430\u0434\u0430\u043B\u0438\u0441\u044C \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u043C \u2013  \u0432 \u043A\u0430\u043A\u043E\u0439 \u0441\u0440\u043E\u043A \u0442\u0435\u043F\u0435\u0440\u044C \u043C\u043E\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u044F?</p>',
      answers: [{
        title: 'Не повезло молодой семье. Компания с трудом выживает, ну откуда сейчас деньги? Надежду на пособия придется отложить до лучших времен.',
        next: '2a'
      }, {
        title: 'Конечно, работодатель обязан выплатить работнику деньги из собственных средств! Но финансовые проблемы компании могут привести и к серьезным задержкам выплат, так что даже не знаю…  А уж если фирма обанкротится, то и вовсе не понятно, куда бежать!',
        next: '2b'
      }, {
        title: 'По закону на выплаты социальных пособий из ФСС отводится 10 календарных дней с момента подачи необходимых документов.',
        next: '2c'
      }]
    },
    '2a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-2a.jpg',
      imageAuthor: '',
      comment: '<p>\u041C\u043E\u043B\u043E\u0434\u0430\u044F \u0441\u0435\u043C\u044C\u044F \u041F\u0435\u0448\u043A\u043E\u0432\u044B\u0445 \u2212 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u043D\u0438\u0436\u0435\u0433\u043E\u0440\u043E\u0434\u0441\u043A\u043E\u0439 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0444\u0438\u0440\u043C\u044B \u2212 \u0433\u043E\u0442\u043E\u0432\u0438\u0442\u0441\u044F \u043A \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E. \u0420\u0430\u0434\u043E\u0441\u0442\u043D\u043E\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0435 \u0435\u0449\u0435 \u0432\u043F\u0435\u0440\u0435\u0434\u0438, \u0438 \u0431\u0443\u0434\u0443\u0449\u0430\u044F \u043C\u0430\u043C\u0430 \u0443\u0436\u0435 \u0441\u0435\u0439\u0447\u0430\u0441, \u043D\u0430 \u0440\u0430\u043D\u043D\u0435\u043C \u0441\u0440\u043E\u043A\u0435 \u0431\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0441\u0442\u0438, \u0432\u0441\u0442\u0430\u043B\u0430 \u043D\u0430 \u0443\u0447\u0435\u0442 \u0432 \u0436\u0435\u043D\u0441\u043A\u0443\u044E \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E. \u041D\u043E \u043A\u043E\u0440\u043E\u043D\u0430\u043A\u0440\u0438\u0437\u0438\u0441 \u0437\u0430\u043C\u0435\u0442\u043D\u043E \u043F\u043E\u0448\u0430\u0442\u043D\u0443\u043B \u0432\u0441\u0435 \u043F\u043B\u0430\u043D\u044B \u2013 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0441\u043E\u043A\u0440\u0430\u0442\u0438\u043B\u0430 \u0440\u044F\u0434 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0438 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E \u043F\u0435\u0440\u0435\u0448\u043B\u0430 \u043D\u0430 \u0434\u0438\u0441\u0442\u0430\u043D\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0444\u043E\u0440\u043C\u0443 \u0440\u0430\u0431\u043E\u0442\u044B, \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u044B \u0443\u043C\u0435\u043D\u044C\u0448\u0438\u043B\u0438\u0441\u044C. \u041F\u0435\u0448\u043A\u043E\u0432\u044B \xAB\u0441\u0430\u043C\u043E\u0438\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043B\u0438\u0441\u044C\xBB \u0437\u0430 \u0433\u043E\u0440\u043E\u0434\u043E\u043C \u0438 \u0437\u0430\u0434\u0430\u043B\u0438\u0441\u044C \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u043C \u2013  \u0432 \u043A\u0430\u043A\u043E\u0439 \u0441\u0440\u043E\u043A \u0442\u0435\u043F\u0435\u0440\u044C \u043C\u043E\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u044F?</p>',
      answerList: [['Не повезло молодой семье. Компания с трудом выживает, ну откуда сейчас деньги? Надежду на пособия придется отложить до лучших времен.', 'selected'], ['Конечно, работодатель обязан выплатить работнику деньги из собственных средств! Но финансовые проблемы компании могут привести и к серьезным задержкам выплат, так что даже не знаю…  А уж если фирма обанкротится, то и вовсе не понятно, куда бежать!', false], ['По закону на выплаты социальных пособий из ФСС отводится 10 календарных дней с момента подачи необходимых документов.', false]],
      description: '<p>\u0427\u0442\u043E \u0437\u043D\u0430\u0447\u0438\u0442 \u2212 \u043F\u043E\u0432\u0435\u0437\u043B\u043E \u0438\u043B\u0438 \u043D\u0435 \u043F\u043E\u0432\u0435\u0437\u043B\u043E? \u0412\u0441\u0435 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E \u0442\u0440\u0443\u0434\u043E\u0443\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0435 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0435 \u0420\u0424 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u044B \u0432 \u0424\u0421\u0421 \u0420\u0424 \u0438 \u0438\u043C\u0435\u044E\u0442 \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u043E\u0441\u043E\u0431\u0438\u044F \u0438\u0437 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0424\u043E\u043D\u0434\u0430.</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '2'
    },
    '2b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-2b.jpg',
      imageAuthor: '',
      comment: '<p>\u041C\u043E\u043B\u043E\u0434\u0430\u044F \u0441\u0435\u043C\u044C\u044F \u041F\u0435\u0448\u043A\u043E\u0432\u044B\u0445 \u2212 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u043D\u0438\u0436\u0435\u0433\u043E\u0440\u043E\u0434\u0441\u043A\u043E\u0439 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0444\u0438\u0440\u043C\u044B \u2212 \u0433\u043E\u0442\u043E\u0432\u0438\u0442\u0441\u044F \u043A \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E. \u0420\u0430\u0434\u043E\u0441\u0442\u043D\u043E\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0435 \u0435\u0449\u0435 \u0432\u043F\u0435\u0440\u0435\u0434\u0438, \u0438 \u0431\u0443\u0434\u0443\u0449\u0430\u044F \u043C\u0430\u043C\u0430 \u0443\u0436\u0435 \u0441\u0435\u0439\u0447\u0430\u0441, \u043D\u0430 \u0440\u0430\u043D\u043D\u0435\u043C \u0441\u0440\u043E\u043A\u0435 \u0431\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0441\u0442\u0438, \u0432\u0441\u0442\u0430\u043B\u0430 \u043D\u0430 \u0443\u0447\u0435\u0442 \u0432 \u0436\u0435\u043D\u0441\u043A\u0443\u044E \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E. \u041D\u043E \u043A\u043E\u0440\u043E\u043D\u0430\u043A\u0440\u0438\u0437\u0438\u0441 \u0437\u0430\u043C\u0435\u0442\u043D\u043E \u043F\u043E\u0448\u0430\u0442\u043D\u0443\u043B \u0432\u0441\u0435 \u043F\u043B\u0430\u043D\u044B \u2013 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0441\u043E\u043A\u0440\u0430\u0442\u0438\u043B\u0430 \u0440\u044F\u0434 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0438 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E \u043F\u0435\u0440\u0435\u0448\u043B\u0430 \u043D\u0430 \u0434\u0438\u0441\u0442\u0430\u043D\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0444\u043E\u0440\u043C\u0443 \u0440\u0430\u0431\u043E\u0442\u044B, \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u044B \u0443\u043C\u0435\u043D\u044C\u0448\u0438\u043B\u0438\u0441\u044C. \u041F\u0435\u0448\u043A\u043E\u0432\u044B \xAB\u0441\u0430\u043C\u043E\u0438\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043B\u0438\u0441\u044C\xBB \u0437\u0430 \u0433\u043E\u0440\u043E\u0434\u043E\u043C \u0438 \u0437\u0430\u0434\u0430\u043B\u0438\u0441\u044C \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u043C \u2013  \u0432 \u043A\u0430\u043A\u043E\u0439 \u0441\u0440\u043E\u043A \u0442\u0435\u043F\u0435\u0440\u044C \u043C\u043E\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u044F?</p>',
      answerList: [['Не повезло молодой семье. Компания с трудом выживает, ну откуда сейчас деньги? Надежду на пособия придется отложить до лучших времен.', false], ['Конечно, работодатель обязан выплатить работнику деньги из собственных средств! Но финансовые проблемы компании могут привести и к серьезным задержкам выплат, так что даже не знаю…  А уж если фирма обанкротится, то и вовсе не понятно, куда бежать!', 'selected'], ['По закону на выплаты социальных пособий из ФСС отводится 10 календарных дней с момента подачи необходимых документов.', false]],
      description: '<p>\u0412\u044B \u0443\u043F\u0443\u0441\u0442\u0438\u043B\u0438 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u0432 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u0437\u0430\u0434\u0430\u0447\u0438: \u041F\u0435\u0448\u043A\u043E\u0432\u044B \u2013 \u0438\u0437 \u041D\u0438\u0436\u043D\u0435\u0433\u043E \u041D\u043E\u0432\u0433\u043E\u0440\u043E\u0434\u0430, \u0433\u0434\u0435 \u0435\u0449\u0435 \u0432 2011 \u0433\u043E\u0434\u0443  \u0441\u0442\u0430\u0440\u0442\u043E\u0432\u0430\u043B \u043F\u0440\u043E\u0435\u043A\u0442 \u0424\u0421\u0421 \u0420\u0424 \xAB\u041F\u0440\u044F\u043C\u044B\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B\xBB, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0439 \u043A\u0430\u043A \u0440\u0430\u0437 \u0434\u043B\u044F \u0442\u043E\u0433\u043E, \u0447\u0442\u043E\u0431\u044B \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0437\u0430\u0434\u0435\u0440\u0436\u043A\u0438 \u0432\u044B\u043F\u043B\u0430\u0442, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u044B\u0435 \u043F\u0440\u0438 \u0441\u0442\u0430\u0440\u043E\u043C \u043F\u043E\u0440\u044F\u0434\u043A\u0435 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0441\u043E\u0431\u0438\u0439.</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '2'
    },
    '2c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-2c.jpg',
      imageAuthor: '',
      comment: '<p>\u041C\u043E\u043B\u043E\u0434\u0430\u044F \u0441\u0435\u043C\u044C\u044F \u041F\u0435\u0448\u043A\u043E\u0432\u044B\u0445 \u2212 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u043D\u0438\u0436\u0435\u0433\u043E\u0440\u043E\u0434\u0441\u043A\u043E\u0439 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0444\u0438\u0440\u043C\u044B \u2212 \u0433\u043E\u0442\u043E\u0432\u0438\u0442\u0441\u044F \u043A \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044E. \u0420\u0430\u0434\u043E\u0441\u0442\u043D\u043E\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u0435 \u0435\u0449\u0435 \u0432\u043F\u0435\u0440\u0435\u0434\u0438, \u0438 \u0431\u0443\u0434\u0443\u0449\u0430\u044F \u043C\u0430\u043C\u0430 \u0443\u0436\u0435 \u0441\u0435\u0439\u0447\u0430\u0441, \u043D\u0430 \u0440\u0430\u043D\u043D\u0435\u043C \u0441\u0440\u043E\u043A\u0435 \u0431\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0441\u0442\u0438, \u0432\u0441\u0442\u0430\u043B\u0430 \u043D\u0430 \u0443\u0447\u0435\u0442 \u0432 \u0436\u0435\u043D\u0441\u043A\u0443\u044E \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044E. \u041D\u043E \u043A\u043E\u0440\u043E\u043D\u0430\u043A\u0440\u0438\u0437\u0438\u0441 \u0437\u0430\u043C\u0435\u0442\u043D\u043E \u043F\u043E\u0448\u0430\u0442\u043D\u0443\u043B \u0432\u0441\u0435 \u043F\u043B\u0430\u043D\u044B \u2013 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0441\u043E\u043A\u0440\u0430\u0442\u0438\u043B\u0430 \u0440\u044F\u0434 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0438 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E \u043F\u0435\u0440\u0435\u0448\u043B\u0430 \u043D\u0430 \u0434\u0438\u0441\u0442\u0430\u043D\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0444\u043E\u0440\u043C\u0443 \u0440\u0430\u0431\u043E\u0442\u044B, \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u044B \u0443\u043C\u0435\u043D\u044C\u0448\u0438\u043B\u0438\u0441\u044C. \u041F\u0435\u0448\u043A\u043E\u0432\u044B \xAB\u0441\u0430\u043C\u043E\u0438\u0437\u043E\u043B\u0438\u0440\u043E\u0432\u0430\u043B\u0438\u0441\u044C\xBB \u0437\u0430 \u0433\u043E\u0440\u043E\u0434\u043E\u043C \u0438 \u0437\u0430\u0434\u0430\u043B\u0438\u0441\u044C \u0432\u043E\u043F\u0440\u043E\u0441\u043E\u043C \u2013  \u0432 \u043A\u0430\u043A\u043E\u0439 \u0441\u0440\u043E\u043A \u0442\u0435\u043F\u0435\u0440\u044C \u043C\u043E\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u044F?</p>',
      answerList: [['Не повезло молодой семье. Компания с трудом выживает, ну откуда сейчас деньги? Надежду на пособия придется отложить до лучших времен.', false], ['Конечно, работодатель обязан выплатить работнику деньги из собственных средств! Но финансовые проблемы компании могут привести и к серьезным задержкам выплат, так что даже не знаю…  А уж если фирма обанкротится, то и вовсе не понятно, куда бежать!', false], ['По закону на выплаты социальных пособий из ФСС отводится 10 календарных дней с момента подачи необходимых документов.', 'selected']],
      description: '<p>\u0421\u043E\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E \u0432\u0435\u0440\u043D\u043E! \u0412 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 5 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u043D\u044B\u0445 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u0430\u0447\u0438 \u041F\u0435\u0448\u043A\u043E\u0432\u044B\u043C\u0438 \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0438\u0445 \u0440\u0430\u0431\u043E\u0442\u043E\u0434\u0430\u0442\u0435\u043B\u044C \u0438\u0437 \u041D\u0438\u0436\u043D\u0435\u0433\u043E \u041D\u043E\u0432\u0433\u043E\u0440\u043E\u0434\u0430 \u0434\u043E\u043B\u0436\u0435\u043D \u043F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E \u0440\u0430\u0431\u043E\u0442\u043D\u0438\u043A\u0435 \u0432 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0424\u043E\u043D\u0434, \u043E\u0442\u043A\u0443\u0434\u0430 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u043D\u043E\u043C\u0443 \u043B\u0438\u0446\u0443 \u043D\u0430\u043F\u0440\u044F\u043C\u0443\u044E \u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u044F\u0442 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430.</p>',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '3'
    },
    '3': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-3.jpg',
      imageAuthor: '',
      description: '<p>\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043A\u043E\u0440\u043E\u043D\u0430\u043A\u0440\u0438\u0437\u0438\u0441 \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0432\u043B\u0435\u0447\u044C \u0437\u0430 \u0441\u043E\u0431\u043E\u0439, \u043F\u043E \u043C\u043D\u0435\u043D\u0438\u044E \u0421\u041C\u0418, \u0431\u0443\u043C \u0431\u0430\u043D\u043A\u0440\u043E\u0442\u0441\u0442\u0432.  \u041A\u0442\u043E \u0436\u0435 \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0442\u044C \u0441\u0435\u043C\u044C\u0435 \u041F\u0435\u0448\u043A\u043E\u0432\u044B\u0445 \u0438\u0437 \u041D\u0438\u0436\u043D\u0435\u0433\u043E \u041D\u043E\u0432\u0433\u043E\u0440\u043E\u0434\u0430 \u0434\u0435\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u043F\u043E\u0441\u043E\u0431\u0438\u044F, \u0435\u0441\u043B\u0438 \u0438\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0431\u0443\u0434\u0435\u0442 \u043B\u0438\u043A\u0432\u0438\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0430?</p>',
      answers: [{
        title: 'Надо срочно начинать хлопотать самим – искать список нужных документов, записываться в очередь на прием к чиновникам, чтобы отвезти бумаги, ну и запастись терпением – когда придут деньги, сказать сложно. Ведь пособия положены только работающим гражданам!',
        next: '3a'
      }, {
        title: 'Да сразу надо писать жалобу в трудовую инспекцию, пусть проверят там вашего работодателя! А лучше – в суд!',
        next: '3b'
      }, {
        title: 'Обратиться на сайт ФСС РФ и внимательно изучить информацию о проекте «Прямые выплаты». А также прочитать подробные разъясняющие статьи на нашем сайте.',
        next: '3c'
      }]
    },
    '3a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-3a.jpg',
      imageAuthor: '',
      comment: '<p>\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043A\u043E\u0440\u043E\u043D\u0430\u043A\u0440\u0438\u0437\u0438\u0441 \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0432\u043B\u0435\u0447\u044C \u0437\u0430 \u0441\u043E\u0431\u043E\u0439, \u043F\u043E \u043C\u043D\u0435\u043D\u0438\u044E \u0421\u041C\u0418, \u0431\u0443\u043C \u0431\u0430\u043D\u043A\u0440\u043E\u0442\u0441\u0442\u0432.  \u041A\u0442\u043E \u0436\u0435 \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0442\u044C \u0441\u0435\u043C\u044C\u0435 \u041F\u0435\u0448\u043A\u043E\u0432\u044B\u0445 \u0438\u0437 \u041D\u0438\u0436\u043D\u0435\u0433\u043E \u041D\u043E\u0432\u0433\u043E\u0440\u043E\u0434\u0430 \u0434\u0435\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u043F\u043E\u0441\u043E\u0431\u0438\u044F, \u0435\u0441\u043B\u0438 \u0438\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0431\u0443\u0434\u0435\u0442 \u043B\u0438\u043A\u0432\u0438\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0430?</p>',
      answerList: [['Надо срочно начинать хлопотать самим – искать список нужных документов, записываться в очередь на прием к чиновникам, чтобы отвезти бумаги, ну и запастись терпением – когда придут деньги, сказать сложно. Ведь пособия положены только работающим гражданам!', 'selected'], ['Да сразу надо писать жалобу в трудовую инспекцию, пусть проверят там вашего работодателя! А лучше – в суд!', false], ['Обратиться на сайт ФСС РФ и внимательно изучить информацию о проекте «Прямые выплаты». А также прочитать подробные разъясняющие статьи на нашем сайте.', false]],
      description: '<p>\u0418\u0437\u0443\u0447\u0438\u0442\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043F\u043E \u0442\u0435\u043C\u0435 <a href="https://www.mk.ru/social/2020/11/06/kto-vyplatit-detskie-posobiya-esli-rabotodatel-bankrot.html" target="_blank">\xAB\u0415\u0441\u043B\u0438 \u0440\u0430\u0431\u043E\u0442\u043E\u0434\u0430\u0442\u0435\u043B\u044C \u2013 \u0431\u0430\u043D\u043A\u0440\u043E\u0442\xBB</a> \u043D\u0430 \u043D\u0430\u0448\u0435\u043C \u0441\u0430\u0439\u0442\u0435, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u043D\u0430 \u0441\u0430\u0439\u0442 \u0424\u0421\u0421 \u0420\u0424 \u0432 \u0440\u0430\u0437\u0434\u0435\u043B \xAB\u0413\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438\xBB.</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '3'
    },
    '3b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-3b.jpg',
      imageAuthor: '',
      comment: '<p>\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043A\u043E\u0440\u043E\u043D\u0430\u043A\u0440\u0438\u0437\u0438\u0441 \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0432\u043B\u0435\u0447\u044C \u0437\u0430 \u0441\u043E\u0431\u043E\u0439, \u043F\u043E \u043C\u043D\u0435\u043D\u0438\u044E \u0421\u041C\u0418, \u0431\u0443\u043C \u0431\u0430\u043D\u043A\u0440\u043E\u0442\u0441\u0442\u0432.  \u041A\u0442\u043E \u0436\u0435 \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0442\u044C \u0441\u0435\u043C\u044C\u0435 \u041F\u0435\u0448\u043A\u043E\u0432\u044B\u0445 \u0438\u0437 \u041D\u0438\u0436\u043D\u0435\u0433\u043E \u041D\u043E\u0432\u0433\u043E\u0440\u043E\u0434\u0430 \u0434\u0435\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u043F\u043E\u0441\u043E\u0431\u0438\u044F, \u0435\u0441\u043B\u0438 \u0438\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0431\u0443\u0434\u0435\u0442 \u043B\u0438\u043A\u0432\u0438\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0430?</p>',
      answerList: [['Надо срочно начинать хлопотать самим – искать список нужных документов, записываться в очередь на прием к чиновникам, чтобы отвезти бумаги, ну и запастись терпением – когда придут деньги, сказать сложно. Ведь пособия положены только работающим гражданам!', false], ['Да сразу надо писать жалобу в трудовую инспекцию, пусть проверят там вашего работодателя! А лучше – в суд!', 'selected'], ['Обратиться на сайт ФСС РФ и внимательно изучить информацию о проекте «Прямые выплаты». А также прочитать подробные разъясняющие статьи на нашем сайте.', false]],
      description: '<p>\u0410 \u0432\u0435\u0434\u044C \u043D\u0435\u043F\u043B\u043E\u0445\u043E\u0439 \u0441\u043E\u0432\u0435\u0442! \u0415\u0441\u043B\u0438 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0438 \u0438\u043C\u0435\u0435\u0442 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430, \u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u043D\u0435 \u043F\u043E\u0441\u0442\u0443\u043F\u0430\u044E\u0442, \u0442\u043E \u0440\u0430\u0431\u043E\u0442\u043D\u0438\u043A \u043C\u043E\u0436\u0435\u0442 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u044C\u0441\u044F \u0432 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0438\u043D\u0441\u0442\u0430\u043D\u0446\u0438\u0438. \u0410 \u0435\u0441\u043B\u0438 \u0440\u0430\u0431\u043E\u0442\u043E\u0434\u0430\u0442\u0435\u043B\u044C \u2013 \u0431\u0430\u043D\u043A\u0440\u043E\u0442?</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '3'
    },
    '3c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-3c.jpg',
      imageAuthor: '',
      comment: '<p>\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043A\u043E\u0440\u043E\u043D\u0430\u043A\u0440\u0438\u0437\u0438\u0441 \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0432\u043B\u0435\u0447\u044C \u0437\u0430 \u0441\u043E\u0431\u043E\u0439, \u043F\u043E \u043C\u043D\u0435\u043D\u0438\u044E \u0421\u041C\u0418, \u0431\u0443\u043C \u0431\u0430\u043D\u043A\u0440\u043E\u0442\u0441\u0442\u0432.  \u041A\u0442\u043E \u0436\u0435 \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0442\u044C \u0441\u0435\u043C\u044C\u0435 \u041F\u0435\u0448\u043A\u043E\u0432\u044B\u0445 \u0438\u0437 \u041D\u0438\u0436\u043D\u0435\u0433\u043E \u041D\u043E\u0432\u0433\u043E\u0440\u043E\u0434\u0430 \u0434\u0435\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u043F\u043E\u0441\u043E\u0431\u0438\u044F, \u0435\u0441\u043B\u0438 \u0438\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u0431\u0443\u0434\u0435\u0442 \u043B\u0438\u043A\u0432\u0438\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0430?</p>',
      answerList: [['Надо срочно начинать хлопотать самим – искать список нужных документов, записываться в очередь на прием к чиновникам, чтобы отвезти бумаги, ну и запастись терпением – когда придут деньги, сказать сложно. Ведь пособия положены только работающим гражданам!', false], ['Да сразу надо писать жалобу в трудовую инспекцию, пусть проверят там вашего работодателя! А лучше – в суд!', false], ['Обратиться на сайт ФСС РФ и внимательно изучить информацию о проекте «Прямые выплаты». А также прочитать подробные разъясняющие статьи на нашем сайте.', 'selected']],
      description: '<p>\u041E\u0442\u043B\u0438\u0447\u043D\u043E\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u0435! <a href="https://www.mk.ru/social/2020/11/06/pryamye-vyplaty-shagayut-po-rossii.html" target="_blank">\u0412\u043E\u0442 \u043F\u043E\u0434\u0431\u043E\u0440\u043A\u0430 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432</a>, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043F\u043E\u043C\u043E\u0433\u0443\u0442 \u0441\u0435\u043C\u044C\u0435 \u041F\u0435\u0448\u043A\u043E\u0432\u044B\u0445 \u0433\u0440\u0430\u043C\u043E\u0442\u043D\u043E \u0438 \u043E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u043E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u044F.</p>',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '4'
    },
    '4': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-4.jpg',
      imageAuthor: '',
      description: '<p>\u041F\u043E\u043C\u043D\u0438\u0442\u0435 \u0444\u0438\u043B\u044C\u043C \xAB\u0414\u0435\u0442\u0438 \u0414\u043E\u043D \u041A\u0438\u0445\u043E\u0442\u0430\xBB? \u0412 \u0441\u0435\u043C\u044C\u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0441\u043D\u043E\u0433\u043E \u0432\u0440\u0430\u0447\u0430 \u041F\u0435\u0442\u0440\u0430 \u0411\u043E\u043D\u0434\u0430\u0440\u0435\u043D\u043A\u043E \u0442\u0440\u043E\u0435 \u0441\u044B\u043D\u043E\u0432\u0435\u0439. \u0412\u0438\u043A\u0442\u043E\u0440 \u0438 \u0414\u043C\u0438\u0442\u0440\u0438\u0439 \u0443\u0436\u0435 \u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0435, \u042E\u0440\u0430 \u2212 \u0448\u043A\u043E\u043B\u044C\u043D\u0438\u043A. \u0412\u0441\u043A\u043E\u0440\u0435 \u0432 \u0434\u043E\u043C\u0435 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u044B\u0439 \u0440\u0435\u0431\u0435\u043D\u043E\u043A \u2013 \u0441\u043E\u0432\u0441\u0435\u043C \u043C\u0430\u043B\u044B\u0448. \u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043C \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u044E \u0432 2020 \u0433\u043E\u0434 \u0438 \u043F\u043E\u043C\u043E\u0436\u0435\u043C \u0433\u0435\u0440\u043E\u044E \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u044F \u041F\u0430\u043F\u0430\u043D\u043E\u0432\u0430 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u043E\u0433\u043E \u0434\u0435\u0442\u0441\u043A\u043E\u0433\u043E \u043F\u043E\u0441\u043E\u0431\u0438\u044F!  </p>',
      answers: [{
        title: 'Пусть Вера − мама теперь уже четверых сыновей − оформит отпуск по уходу за ребенком. В бухгалтерии института красоты, где она работает, ей сделают правильный расчет, в зависимости от ее ежемесячного заработка и заработка других членов семьи.',
        next: '4a'
      }, {
        title: 'Все Бондаренко должны обсудить, кто из старших членов семьи и на какой срок сможет «уйти в декрет» для ухода за младшим сынишкой.',
        next: '4b'
      }, {
        title: 'Размер пособия по уходу за ребенком напрямую зависит от заработной платы члена семьи, который оформит соответствующий отпуск, и составляет 40% от этой величины.',
        next: '4c'
      }]
    },
    '4a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-4a.jpg',
      imageAuthor: '',
      comment: '<p>\u041F\u043E\u043C\u043D\u0438\u0442\u0435 \u0444\u0438\u043B\u044C\u043C \xAB\u0414\u0435\u0442\u0438 \u0414\u043E\u043D \u041A\u0438\u0445\u043E\u0442\u0430\xBB? \u0412 \u0441\u0435\u043C\u044C\u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0441\u043D\u043E\u0433\u043E \u0432\u0440\u0430\u0447\u0430 \u041F\u0435\u0442\u0440\u0430 \u0411\u043E\u043D\u0434\u0430\u0440\u0435\u043D\u043A\u043E \u0442\u0440\u043E\u0435 \u0441\u044B\u043D\u043E\u0432\u0435\u0439. \u0412\u0438\u043A\u0442\u043E\u0440 \u0438 \u0414\u043C\u0438\u0442\u0440\u0438\u0439 \u0443\u0436\u0435 \u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0435, \u042E\u0440\u0430 \u2212 \u0448\u043A\u043E\u043B\u044C\u043D\u0438\u043A. \u0412\u0441\u043A\u043E\u0440\u0435 \u0432 \u0434\u043E\u043C\u0435 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u044B\u0439 \u0440\u0435\u0431\u0435\u043D\u043E\u043A \u2013 \u0441\u043E\u0432\u0441\u0435\u043C \u043C\u0430\u043B\u044B\u0448. \u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043C \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u044E \u0432 2020 \u0433\u043E\u0434 \u0438 \u043F\u043E\u043C\u043E\u0436\u0435\u043C \u0433\u0435\u0440\u043E\u044E \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u044F \u041F\u0430\u043F\u0430\u043D\u043E\u0432\u0430 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u043E\u0433\u043E \u0434\u0435\u0442\u0441\u043A\u043E\u0433\u043E \u043F\u043E\u0441\u043E\u0431\u0438\u044F!  </p>',
      answerList: [['Пусть Вера − мама теперь уже четверых сыновей − оформит отпуск по уходу за ребенком. В бухгалтерии института красоты, где она работает, ей сделают правильный расчет, в зависимости от ее ежемесячного заработка и заработка других членов семьи.', 'selected'], ['Все Бондаренко должны обсудить, кто из старших членов семьи и на какой срок сможет «уйти в декрет» для ухода за младшим сынишкой.', false], ['Размер пособия по уходу за ребенком напрямую зависит от заработной платы члена семьи, который оформит соответствующий отпуск, и составляет 40% от этой величины.', false]],
      description: '<p>\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0441\u043E\u0432\u0435\u0442. \u0412\u043E-\u043F\u0435\u0440\u0432\u044B\u0445, \u043E\u0442\u043F\u0443\u0441\u043A \u043F\u043E \u0443\u0445\u043E\u0434\u0443 \u0437\u0430 \u0440\u0435\u0431\u0435\u043D\u043A\u043E\u043C \u043C\u043E\u0436\u0435\u0442 \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u0438 \u043E\u0442\u0435\u0446 \u0441\u0435\u043C\u0435\u0439\u0441\u0442\u0432\u0430. \u0412\u043E-\u0432\u0442\u043E\u0440\u044B\u0445, \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0441\u0447\u0435\u0442 \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u043A\u0430\u0436\u0434\u044B\u0439 \u043C\u043E\u0436\u0435\u0442 \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0441\u0430\u043C, \u043E\u0431\u0440\u0430\u0442\u0438\u0432\u0448\u0438\u0441\u044C, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u043D\u0430 \u0441\u0430\u0439\u0442 \u0424\u0421\u0421 \u0420\u0424</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '4'
    },
    '4b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-4b.jpg',
      imageAuthor: '',
      comment: '<p>\u041F\u043E\u043C\u043D\u0438\u0442\u0435 \u0444\u0438\u043B\u044C\u043C \xAB\u0414\u0435\u0442\u0438 \u0414\u043E\u043D \u041A\u0438\u0445\u043E\u0442\u0430\xBB? \u0412 \u0441\u0435\u043C\u044C\u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0441\u043D\u043E\u0433\u043E \u0432\u0440\u0430\u0447\u0430 \u041F\u0435\u0442\u0440\u0430 \u0411\u043E\u043D\u0434\u0430\u0440\u0435\u043D\u043A\u043E \u0442\u0440\u043E\u0435 \u0441\u044B\u043D\u043E\u0432\u0435\u0439. \u0412\u0438\u043A\u0442\u043E\u0440 \u0438 \u0414\u043C\u0438\u0442\u0440\u0438\u0439 \u0443\u0436\u0435 \u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0435, \u042E\u0440\u0430 \u2212 \u0448\u043A\u043E\u043B\u044C\u043D\u0438\u043A. \u0412\u0441\u043A\u043E\u0440\u0435 \u0432 \u0434\u043E\u043C\u0435 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u044B\u0439 \u0440\u0435\u0431\u0435\u043D\u043E\u043A \u2013 \u0441\u043E\u0432\u0441\u0435\u043C \u043C\u0430\u043B\u044B\u0448. \u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043C \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u044E \u0432 2020 \u0433\u043E\u0434 \u0438 \u043F\u043E\u043C\u043E\u0436\u0435\u043C \u0433\u0435\u0440\u043E\u044E \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u044F \u041F\u0430\u043F\u0430\u043D\u043E\u0432\u0430 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u043E\u0433\u043E \u0434\u0435\u0442\u0441\u043A\u043E\u0433\u043E \u043F\u043E\u0441\u043E\u0431\u0438\u044F!</p>',
      answerList: [['Пусть Вера − мама теперь уже четверых сыновей − оформит отпуск по уходу за ребенком. В бухгалтерии института красоты, где она работает, ей сделают правильный расчет, в зависимости от ее ежемесячного заработка и заработка других членов семьи.', false], ['Все Бондаренко должны обсудить, кто из старших членов семьи и на какой срок сможет «уйти в декрет» для ухода за младшим сынишкой.', 'selected'], ['Размер пособия по уходу за ребенком напрямую зависит от заработной платы члена семьи, который оформит соответствующий отпуск, и составляет 40% от этой величины.', false]],
      description: '<p>\u0418\u043C\u0435\u043D\u043D\u043E \u0442\u0430\u043A! \u041F\u043E \u0437\u0430\u043A\u043E\u043D\u0443 \u043E\u0442\u043F\u0443\u0441\u043A \u043F\u043E \u0443\u0445\u043E\u0434\u0443 \u0437\u0430 \u043C\u0430\u043B\u044B\u0448\u043E\u043C \u043C\u043E\u0436\u0435\u0442 \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0435\u0433\u043E \u043C\u0430\u043C\u0430, \u043D\u043E \u0438 \u043F\u0430\u043F\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u0435\u0434\u0443\u0448\u043A\u0430 \u0438 \u0431\u0430\u0431\u0443\u0448\u043A\u0430 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u044E\u0449\u0438\u0435 \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0438. \u041D\u043E \u0432\u0441\u0435 \u0436\u0435, \u0432 \u0443\u0441\u043B\u043E\u0432\u0438\u0438 \u0437\u0430\u0434\u0430\u0447\u0438, \u043D\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0438\u043C\u0435\u043D\u043D\u043E \u0440\u0430\u0441\u0447\u0435\u0442.</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '4'
    },
    '4c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-4c.jpg',
      imageAuthor: '',
      comment: '<p>\u041F\u043E\u043C\u043D\u0438\u0442\u0435 \u0444\u0438\u043B\u044C\u043C \xAB\u0414\u0435\u0442\u0438 \u0414\u043E\u043D \u041A\u0438\u0445\u043E\u0442\u0430\xBB? \u0412 \u0441\u0435\u043C\u044C\u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0441\u043D\u043E\u0433\u043E \u0432\u0440\u0430\u0447\u0430 \u041F\u0435\u0442\u0440\u0430 \u0411\u043E\u043D\u0434\u0430\u0440\u0435\u043D\u043A\u043E \u0442\u0440\u043E\u0435 \u0441\u044B\u043D\u043E\u0432\u0435\u0439. \u0412\u0438\u043A\u0442\u043E\u0440 \u0438 \u0414\u043C\u0438\u0442\u0440\u0438\u0439 \u0443\u0436\u0435 \u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0435, \u042E\u0440\u0430 \u2212 \u0448\u043A\u043E\u043B\u044C\u043D\u0438\u043A. \u0412\u0441\u043A\u043E\u0440\u0435 \u0432 \u0434\u043E\u043C\u0435 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0447\u0435\u0442\u0432\u0435\u0440\u0442\u044B\u0439 \u0440\u0435\u0431\u0435\u043D\u043E\u043A \u2013 \u0441\u043E\u0432\u0441\u0435\u043C \u043C\u0430\u043B\u044B\u0448. \u041F\u0435\u0440\u0435\u043D\u0435\u0441\u0435\u043C \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u044E \u0432 2020 \u0433\u043E\u0434 \u0438 \u043F\u043E\u043C\u043E\u0436\u0435\u043C \u0433\u0435\u0440\u043E\u044E \u0410\u043D\u0430\u0442\u043E\u043B\u0438\u044F \u041F\u0430\u043F\u0430\u043D\u043E\u0432\u0430 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u043E\u0433\u043E \u0434\u0435\u0442\u0441\u043A\u043E\u0433\u043E \u043F\u043E\u0441\u043E\u0431\u0438\u044F!  </p>',
      answerList: [['Пусть Вера − мама теперь уже четверых сыновей − оформит отпуск по уходу за ребенком. В бухгалтерии института красоты, где она работает, ей сделают правильный расчет, в зависимости от ее ежемесячного заработка и заработка других членов семьи.', false], ['Все Бондаренко должны обсудить, кто из старших членов семьи и на какой срок сможет «уйти в декрет» для ухода за младшим сынишкой.', false], ['Размер пособия по уходу за ребенком напрямую зависит от заработной платы члена семьи, который оформит соответствующий отпуск, и составляет 40% от этой величины.', 'selected']],
      description: '<p>\u041F\u0440\u0438\u0432\u0435\u0434\u0435\u043C \u043F\u0440\u0438\u043C\u0435\u0440 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0433\u043E \u0440\u0430\u0441\u0447\u0435\u0442\u0430. \u041F\u0443\u0441\u0442\u044C \u0412\u0435\u0440\u0430 \u0411\u043E\u043D\u0434\u0430\u0440\u0435\u043D\u043A\u043E \u0437\u0430 2018 \u0438 2019 \u0433\u043E\u0434\u044B \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u043B\u0430 1 070 000 \u0440\u0443\u0431\u043B\u0435\u0439. \u0421\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E, \u0435\u0435 \u0441\u0440\u0435\u0434\u043D\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u0430\u044F \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u0430 \u0441\u043E\u0441\u0442\u0430\u0432\u0438\u043B\u0430 44558,8 \u0440\u0443\u0431\u043B\u044F (1070000/730*30,4). \u0422\u0430\u043A\u0438\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C, \u0432 \u043E\u0442\u043F\u0443\u0441\u043A\u0435 \u043F\u043E \u0443\u0445\u043E\u0434\u0443 \u0437\u0430 \u0440\u0435\u0431\u0435\u043D\u043A\u043E\u043C \u0434\u043E 1,5 \u0433\u043E\u0434\u0430 \u043E\u043D\u0430 \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C 40% \u043E\u0442 \u0441\u0432\u043E\u0435\u0433\u043E \u0441\u0440\u0435\u0434\u043D\u0435\u0433\u043E \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u043A\u0430, \u0442\u043E \u0435\u0441\u0442\u044C \u0447\u0443\u0442\u044C \u0431\u043E\u043B\u0435\u0435 17823,52 \u0440\u0443\u0431\u043B\u044F.</p>',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '5'
    },
    '5': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-5.jpg',
      imageAuthor: '',
      description: '<p>\u041A\u0430\u043A \u0432\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0435, \u043A\u0430\u043A\u043E\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0441\u0430\u043C\u044B\u0439 \u0443\u0434\u043E\u0431\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u0435 \u0438\u0437 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0424\u043E\u043D\u0434\u0430 \u0441\u043E\u0446\u0441\u0442\u0440\u0430\u0445\u0430  \u0434\u043B\u044F \u0431\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445 \u0436\u0435\u043D\u0449\u0438\u043D \u0438 \u0441\u0435\u043C\u0435\u0439 \u0441 \u0434\u0435\u0442\u044C\u043C\u0438?</p>',
      answers: [{
        title: 'Конечно, наличными!',
        next: '5a'
      }, {
        title: 'Сейчас у всех счет в банке, наверное, туда можно. В крайнем случае − почтовым переводом.',
        next: '5b'
      }, {
        title: 'Карта «МИР».',
        next: '5c'
      }]
    },
    '5a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-5a.jpg',
      imageAuthor: '',
      comment: '<p>\u041A\u0430\u043A \u0432\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0435, \u043A\u0430\u043A\u043E\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0441\u0430\u043C\u044B\u0439 \u0443\u0434\u043E\u0431\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u0435 \u0438\u0437 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0424\u043E\u043D\u0434\u0430 \u0441\u043E\u0446\u0441\u0442\u0440\u0430\u0445\u0430  \u0434\u043B\u044F \u0431\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445 \u0436\u0435\u043D\u0449\u0438\u043D \u0438 \u0441\u0435\u043C\u0435\u0439 \u0441 \u0434\u0435\u0442\u044C\u043C\u0438?</p>',
      answerList: [['Конечно, наличными!', 'selected'], ['Сейчас у всех счет в банке, наверное, туда можно. В крайнем случае − почтовым переводом.', false], ['Карта «МИР».', false]],
      description: '<p>\u0415\u0441\u043B\u0438 \u0432\u0430\u0448 \u0440\u0435\u0433\u0438\u043E\u043D \u0435\u0449\u0435 \u043D\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u043B\u0441\u044F \u043A \xAB\u041F\u0440\u044F\u043C\u044B\u043C \u0432\u044B\u043F\u043B\u0430\u0442\u0430\u043C\xBB, \u0442\u043E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u044F \u043C\u043E\u0436\u043D\u043E \u0432 \u043A\u0430\u0441\u0441\u0435 \u0440\u0430\u0431\u043E\u0442\u043E\u0434\u0430\u0442\u0435\u043B\u044F. \u0410 \u0435\u0441\u043B\u0438 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u044F\u0442\u0438\u0435 \u043B\u0438\u043A\u0432\u0438\u0434\u0438\u0440\u0443\u0435\u0442\u0441\u044F?</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '5'
    },
    '5b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-5b.jpg',
      imageAuthor: '',
      comment: '<p>\u041A\u0430\u043A \u0432\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0435, \u043A\u0430\u043A\u043E\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0441\u0430\u043C\u044B\u0439 \u0443\u0434\u043E\u0431\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u0435 \u0438\u0437 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0424\u043E\u043D\u0434\u0430 \u0441\u043E\u0446\u0441\u0442\u0440\u0430\u0445\u0430  \u0434\u043B\u044F \u0431\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445 \u0436\u0435\u043D\u0449\u0438\u043D \u0438 \u0441\u0435\u043C\u0435\u0439 \u0441 \u0434\u0435\u0442\u044C\u043C\u0438?</p>',
      answerList: [['Конечно, наличными!', false], ['Сейчас у всех счет в банке, наверное, туда можно. В крайнем случае − почтовым переводом.', 'selected'], ['Карта «МИР».', false]],
      description: '<p>\u041F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0438\u0442\u044C \u043D\u0430 \u0432\u0430\u0448 \u0441\u0447\u0435\u0442 \u0432 \u0431\u0430\u043D\u043A\u0435 \u0438 \u0432 \u043E\u0442\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u043F\u043E\u0447\u0442\u044B \u043F\u043E \u043C\u0435\u0441\u0442\u0443 \u0436\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043C\u043E\u0436\u0435\u0442 \u043A\u0430\u043A \u0440\u0430\u0431\u043E\u0442\u043E\u0434\u0430\u0442\u0435\u043B\u044C, \u0442\u0430\u043A \u0438 \u0424\u043E\u043D\u0434 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F (\u0432 \u0440\u0435\u0433\u0438\u043E\u043D\u0430\u0445 \u0441 \xAB\u041F\u0440\u044F\u043C\u044B\u043C\u0438 \u0432\u044B\u043F\u043B\u0430\u0442\u0430\u043C\u0438\xBB). \u041D\u043E \u0442\u0430\u043A \u043B\u0438 \u044D\u0442\u043E \u0431\u044B\u0441\u0442\u0440\u043E \u0438 \u0443\u0434\u043E\u0431\u043D\u043E?</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '5'
    },
    '5c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-5c.jpg',
      imageAuthor: '',
      comment: '<p>\u041A\u0430\u043A \u0432\u044B \u0441\u0447\u0438\u0442\u0430\u0435\u0442\u0435, \u043A\u0430\u043A\u043E\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0441\u0430\u043C\u044B\u0439 \u0443\u0434\u043E\u0431\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043E\u0431\u0438\u0435 \u0438\u0437 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0424\u043E\u043D\u0434\u0430 \u0441\u043E\u0446\u0441\u0442\u0440\u0430\u0445\u0430  \u0434\u043B\u044F \u0431\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445 \u0436\u0435\u043D\u0449\u0438\u043D \u0438 \u0441\u0435\u043C\u0435\u0439 \u0441 \u0434\u0435\u0442\u044C\u043C\u0438?</p>',
      answerList: [['Конечно, наличными!', false], ['Сейчас у всех счет в банке, наверное, туда можно. В крайнем случае − почтовым переводом.', false], ['Карта «МИР».', 'selected']],
      description: '<p>\u0414\u0430, \u0432 \u0440\u0435\u0433\u0438\u043E\u043D\u0430\u0445, \u0433\u0434\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u043C\u0435\u0445\u0430\u043D\u0438\u0437\u043C \xAB\u041F\u0440\u044F\u043C\u044B\u0435 \u0432\u044B\u043F\u043B\u0430\u0442\u044B\xBB, \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0432\u044B\u043F\u043B\u0430\u0442 \u043D\u0430 \u043A\u0430\u0440\u0442\u0443 \xAB\u041C\u0418\u0420\xBB \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0443\u043A\u0430\u0437\u0430\u0442\u044C \u043B\u0438\u0448\u044C \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0440\u0442\u044B, \u0438 \u0434\u0435\u043D\u044C\u0433\u0438 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C \u0447\u0435\u0440\u0435\u0437 30 \u043C\u0438\u043D\u0443\u0442 \u043F\u043E\u0441\u043B\u0435 \u0438\u0445 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0438\u0437 \u0424\u0421\u0421.</p>',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '6'
    },
    '6': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-6.jpg',
      imageAuthor: '',
      description: '<p>\u041F\u043E\u043C\u043D\u0438\u0442\u0435 \u043A\u0430\u043F\u0438\u0442\u0430\u043D\u0430 \u041A\u043E\u043F\u0435\u0439\u043A\u0438\u043D\u0430 \u0438\u0437 \u0433\u043E\u0433\u043E\u043B\u0435\u0432\u0441\u043A\u0438\u0445 \xAB\u041C\u0435\u0440\u0442\u0432\u044B\u0445 \u0434\u0443\u0448\xBB, \u043A\u043E\u0442\u043E\u0440\u044B\u0439, \u0441\u0442\u0430\u0432 \u0438\u043D\u0432\u0430\u043B\u0438\u0434\u043E\u043C \u043D\u0430 \u0432\u043E\u0439\u043D\u0435 1812 \u0433\u043E\u0434\u0430, \u0442\u0430\u043A \u0438 \u043D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B \u043D\u0438\u043A\u0430\u043A\u043E\u0439 \u043F\u043E\u043C\u043E\u0449\u0438 \u043E\u0442 \u0440\u0430\u0432\u043D\u043E\u0434\u0443\u0448\u043D\u044B\u0445 \u0447\u0438\u043D\u043E\u0432\u043D\u0438\u043A\u043E\u0432? \u041A\u043E\u043D\u0435\u0447\u043D\u043E, \u0438 \u0432 \u0425\u0425I \u0432\u0435\u043A\u0435 \u043D\u0438\u043A\u0442\u043E \u043D\u0435 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D \u043E\u0442 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0437\u0430\u0431\u043E\u043B\u0435\u0432\u0430\u043D\u0438\u0439 \u0438\u043B\u0438 \u043D\u0435\u0441\u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u0441\u043B\u0443\u0447\u0430\u0435\u0432 \u043D\u0430 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0435. \u041D\u043E \u0432 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432 \u0420\u0424 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F \u2013 \u043A\u0430\u043A \u0440\u0430\u0437 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D! \u041F\u043E\u0441\u0442\u0440\u0430\u0434\u0430\u0432\u0448\u0438\u043C \u0440\u0430\u0431\u043E\u0442\u043D\u0438\u043A\u0430\u043C \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u043F\u043E\u043C\u043E\u0449\u044C \u043E\u0442 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0430. \u0418\u0442\u0430\u043A, \u043A\u0430\u043A\u0438\u0435 \u043C\u0435\u0440\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B \u0424\u043E\u043D\u0434\u043E\u043C \u0441\u043E\u0446\u0441\u0442\u0440\u0430\u0445\u0430 \u0420\u0424 \u043F\u0440\u0438 \u0443\u0442\u0440\u0430\u0442\u0435 \u0442\u0440\u0443\u0434\u043E\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u0438?</p>',
      answers: [{
        title: 'Размер выплат из Фонда зависит от стажа работника и от того, насколько значителен вред здоровью.',
        next: '6a'
      }, {
        title: 'Каждый пострадавший от трудовых травм человек  независимо от стажа получает выплату по больничному листу в размере 100% своего среднего заработка.',
        next: '6b'
      }, {
        title: 'Пострадавшему назначается пожизненная ежемесячная страховая выплата.',
        next: '6c'
      }]
    },
    '6a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-6a.jpg',
      imageAuthor: '',
      comment: '<p>\u041F\u043E\u043C\u043D\u0438\u0442\u0435 \u043A\u0430\u043F\u0438\u0442\u0430\u043D\u0430 \u041A\u043E\u043F\u0435\u0439\u043A\u0438\u043D\u0430 \u0438\u0437 \u0433\u043E\u0433\u043E\u043B\u0435\u0432\u0441\u043A\u0438\u0445 \xAB\u041C\u0435\u0440\u0442\u0432\u044B\u0445 \u0434\u0443\u0448\xBB, \u043A\u043E\u0442\u043E\u0440\u044B\u0439, \u0441\u0442\u0430\u0432 \u0438\u043D\u0432\u0430\u043B\u0438\u0434\u043E\u043C \u043D\u0430 \u0432\u043E\u0439\u043D\u0435 1812 \u0433\u043E\u0434\u0430, \u0442\u0430\u043A \u0438 \u043D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B \u043D\u0438\u043A\u0430\u043A\u043E\u0439 \u043F\u043E\u043C\u043E\u0449\u0438 \u043E\u0442 \u0440\u0430\u0432\u043D\u043E\u0434\u0443\u0448\u043D\u044B\u0445 \u0447\u0438\u043D\u043E\u0432\u043D\u0438\u043A\u043E\u0432? \u041A\u043E\u043D\u0435\u0447\u043D\u043E, \u0438 \u0432 \u0425\u0425I \u0432\u0435\u043A\u0435 \u043D\u0438\u043A\u0442\u043E \u043D\u0435 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D \u043E\u0442 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0437\u0430\u0431\u043E\u043B\u0435\u0432\u0430\u043D\u0438\u0439 \u0438\u043B\u0438 \u043D\u0435\u0441\u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u0441\u043B\u0443\u0447\u0430\u0435\u0432 \u043D\u0430 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0435. \u041D\u043E \u0432 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432 \u0420\u0424 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F \u2013 \u043A\u0430\u043A \u0440\u0430\u0437 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D! \u041F\u043E\u0441\u0442\u0440\u0430\u0434\u0430\u0432\u0448\u0438\u043C \u0440\u0430\u0431\u043E\u0442\u043D\u0438\u043A\u0430\u043C \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u043F\u043E\u043C\u043E\u0449\u044C \u043E\u0442 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0430. \u0418\u0442\u0430\u043A, \u043A\u0430\u043A\u0438\u0435 \u043C\u0435\u0440\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B \u0424\u043E\u043D\u0434\u043E\u043C \u0441\u043E\u0446\u0441\u0442\u0440\u0430\u0445\u0430 \u0420\u0424 \u043F\u0440\u0438 \u0443\u0442\u0440\u0430\u0442\u0435 \u0442\u0440\u0443\u0434\u043E\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u0438?</p>',
      answerList: [['Размер выплат из Фонда зависит от стажа работника и от того, насколько значителен вред здоровью.', 'selected'], ['Каждый пострадавший от трудовых травм человек  независимо от стажа получает выплату по больничному листу в размере 100% своего среднего заработка.', false], ['Пострадавшему назначается пожизненная ежемесячная страховая выплата.', false]],
      description: '<p>\u0422\u0430\u043A\u043E\u0439 \u043E\u0442\u0432\u0435\u0442 \u043C\u043E\u0436\u0435\u0442 \u0432\u0432\u0435\u0441\u0442\u0438 \u0447\u0435\u043B\u043E\u0432\u0435\u043A\u0430 \u0432 \u0437\u0430\u0431\u043B\u0443\u0436\u0434\u0435\u043D\u0438\u0435. \u0418\u0437\u0443\u0447\u0438\u0442\u0435 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B \u0431\u043E\u043B\u0435\u0435 \u0432\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044C\u043D\u043E.</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '6'
    },
    '6b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-6b.jpg',
      imageAuthor: '',
      comment: '<p>\u041F\u043E\u043C\u043D\u0438\u0442\u0435 \u043A\u0430\u043F\u0438\u0442\u0430\u043D\u0430 \u041A\u043E\u043F\u0435\u0439\u043A\u0438\u043D\u0430 \u0438\u0437 \u0433\u043E\u0433\u043E\u043B\u0435\u0432\u0441\u043A\u0438\u0445 \xAB\u041C\u0435\u0440\u0442\u0432\u044B\u0445 \u0434\u0443\u0448\xBB, \u043A\u043E\u0442\u043E\u0440\u044B\u0439, \u0441\u0442\u0430\u0432 \u0438\u043D\u0432\u0430\u043B\u0438\u0434\u043E\u043C \u043D\u0430 \u0432\u043E\u0439\u043D\u0435 1812 \u0433\u043E\u0434\u0430, \u0442\u0430\u043A \u0438 \u043D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B \u043D\u0438\u043A\u0430\u043A\u043E\u0439 \u043F\u043E\u043C\u043E\u0449\u0438 \u043E\u0442 \u0440\u0430\u0432\u043D\u043E\u0434\u0443\u0448\u043D\u044B\u0445 \u0447\u0438\u043D\u043E\u0432\u043D\u0438\u043A\u043E\u0432? \u041A\u043E\u043D\u0435\u0447\u043D\u043E, \u0438 \u0432 \u0425\u0425I \u0432\u0435\u043A\u0435 \u043D\u0438\u043A\u0442\u043E \u043D\u0435 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D \u043E\u0442 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0437\u0430\u0431\u043E\u043B\u0435\u0432\u0430\u043D\u0438\u0439 \u0438\u043B\u0438 \u043D\u0435\u0441\u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u0441\u043B\u0443\u0447\u0430\u0435\u0432 \u043D\u0430 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0435. \u041D\u043E \u0432 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432 \u0420\u0424 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F \u2013 \u043A\u0430\u043A \u0440\u0430\u0437 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D! \u041F\u043E\u0441\u0442\u0440\u0430\u0434\u0430\u0432\u0448\u0438\u043C \u0440\u0430\u0431\u043E\u0442\u043D\u0438\u043A\u0430\u043C \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u043F\u043E\u043C\u043E\u0449\u044C \u043E\u0442 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0430. \u0418\u0442\u0430\u043A, \u043A\u0430\u043A\u0438\u0435 \u043C\u0435\u0440\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B \u0424\u043E\u043D\u0434\u043E\u043C \u0441\u043E\u0446\u0441\u0442\u0440\u0430\u0445\u0430 \u0420\u0424 \u043F\u0440\u0438 \u0443\u0442\u0440\u0430\u0442\u0435 \u0442\u0440\u0443\u0434\u043E\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u0438?</p>',
      answerList: [['Размер выплат из Фонда зависит от стажа работника и от того, насколько значителен вред здоровью.', false], ['Каждый пострадавший от трудовых травм человек  независимо от стажа получает выплату по больничному листу в размере 100% своего среднего заработка.', 'selected'], ['Пострадавшему назначается пожизненная ежемесячная страховая выплата.', false]],
      description: '<p>\u0412\u0435\u0440\u043D\u043E, \u043D\u043E \u043D\u0435 \u0442\u043E\u043B\u044C\u043A\u043E. \u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u0442\u0430\u043A\u0436\u0435 \u0435\u0434\u0438\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u0430 \u043E\u0442 \u0424\u043E\u043D\u0434\u0430. \u042D\u0442\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0430 \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u043F\u0440\u043E\u0446\u0435\u043D\u0442\u0430 \u043F\u043E\u0432\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u044F \u0437\u0434\u043E\u0440\u043E\u0432\u044C\u044F. \u041F\u0440\u0438 100% \u0443\u0442\u0440\u0430\u0442\u0435 \u0437\u0434\u043E\u0440\u043E\u0432\u044C\u044F \u0435\u0434\u0438\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u0430 \u0441 01.02.2020 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 103 527,66 \u0440\u0443\u0431\u043B\u044F.</p>',
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: 'finish'
    },
    '6c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-6с.jpg',
      imageAuthor: '',
      comment: '<p>\u041F\u043E\u043C\u043D\u0438\u0442\u0435 \u043A\u0430\u043F\u0438\u0442\u0430\u043D\u0430 \u041A\u043E\u043F\u0435\u0439\u043A\u0438\u043D\u0430 \u0438\u0437 \u0433\u043E\u0433\u043E\u043B\u0435\u0432\u0441\u043A\u0438\u0445 \xAB\u041C\u0435\u0440\u0442\u0432\u044B\u0445 \u0434\u0443\u0448\xBB, \u043A\u043E\u0442\u043E\u0440\u044B\u0439, \u0441\u0442\u0430\u0432 \u0438\u043D\u0432\u0430\u043B\u0438\u0434\u043E\u043C \u043D\u0430 \u0432\u043E\u0439\u043D\u0435 1812 \u0433\u043E\u0434\u0430, \u0442\u0430\u043A \u0438 \u043D\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u043B \u043D\u0438\u043A\u0430\u043A\u043E\u0439 \u043F\u043E\u043C\u043E\u0449\u0438 \u043E\u0442 \u0440\u0430\u0432\u043D\u043E\u0434\u0443\u0448\u043D\u044B\u0445 \u0447\u0438\u043D\u043E\u0432\u043D\u0438\u043A\u043E\u0432? \u041A\u043E\u043D\u0435\u0447\u043D\u043E, \u0438 \u0432 \u0425\u0425I \u0432\u0435\u043A\u0435 \u043D\u0438\u043A\u0442\u043E \u043D\u0435 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D \u043E\u0442 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0437\u0430\u0431\u043E\u043B\u0435\u0432\u0430\u043D\u0438\u0439 \u0438\u043B\u0438 \u043D\u0435\u0441\u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u0441\u043B\u0443\u0447\u0430\u0435\u0432 \u043D\u0430 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0435. \u041D\u043E \u0432 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432 \u0420\u0424 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F \u2013 \u043A\u0430\u043A \u0440\u0430\u0437 \u0437\u0430\u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D! \u041F\u043E\u0441\u0442\u0440\u0430\u0434\u0430\u0432\u0448\u0438\u043C \u0440\u0430\u0431\u043E\u0442\u043D\u0438\u043A\u0430\u043C \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044C\u043D\u0430\u044F \u043F\u043E\u043C\u043E\u0449\u044C \u043E\u0442 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0430. \u0418\u0442\u0430\u043A, \u043A\u0430\u043A\u0438\u0435 \u043C\u0435\u0440\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B \u0424\u043E\u043D\u0434\u043E\u043C \u0441\u043E\u0446\u0441\u0442\u0440\u0430\u0445\u0430 \u0420\u0424 \u043F\u0440\u0438 \u0443\u0442\u0440\u0430\u0442\u0435 \u0442\u0440\u0443\u0434\u043E\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u0438?</p>',
      answerList: [['Размер выплат из Фонда зависит от стажа работника и от того, насколько значителен вред здоровью.', false], ['Каждый пострадавший от трудовых травм человек  независимо от стажа получает выплату по больничному листу в размере 100% своего среднего заработка.', false], ['Пострадавшему назначается пожизненная ежемесячная страховая выплата.', 'selected']],
      description: '<p>\u041D\u0435 \u0441\u043E\u0432\u0441\u0435\u043C \u0442\u0430\u043A. \u041F\u043E\u043C\u0438\u043C\u043E \u0432\u044B\u043F\u043B\u0430\u0442 \u043F\u043E \u0431\u043E\u043B\u044C\u043D\u0438\u0447\u043D\u043E\u043C\u0443 \u043B\u0438\u0441\u0442\u0443 \u0438 \u0435\u0434\u0438\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0439 \u0432\u044B\u043F\u043B\u0430\u0442\u044B \u0438\u0437 \u0424\u043E\u043D\u0434\u0430 \u043F\u043E\u0441\u0442\u0440\u0430\u0434\u0430\u0432\u0448\u0435\u043C\u0443 \u043D\u0430\u0437\u043D\u0430\u0447\u0430\u0435\u0442\u0441\u044F \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u0430\u044F \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u0430. \u041E\u043D \u0435\u0435 \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0434\u043E \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043F\u043E\u043B\u043D\u043E\u0433\u043E \u0432\u044B\u0437\u0434\u043E\u0440\u043E\u0432\u043B\u0435\u043D\u0438\u044F. \u0415\u0441\u043B\u0438 \u0432\u044B\u0437\u0434\u043E\u0440\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043D\u0435 \u043F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u043E, \u0432\u044B\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u043F\u043E\u0436\u0438\u0437\u043D\u0435\u043D\u043D\u043E, \u043D\u043E \u043D\u0435 \u043D\u0430\u0441\u043B\u0435\u0434\u0443\u0435\u0442\u0441\u044F.</p>',
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '6'
    },
    'finish': {
      type: 'comment',
      imageSrc: './assets/photo/final.jpg',
      imageAuthor: '',
      comment: '\n        <style>.content__answer-list{display:none}.last__bottom-link{text-align:center;margin-bottom:20px;color:#333;font-size:16px;font-weight:400}</style>\n        <p>\u041F\u043E\u0437\u0434\u0440\u0430\u0432\u043B\u044F\u0435\u043C! \u0412\u044B \u0445\u043E\u0440\u043E\u0448\u043E \u043E\u0440\u0438\u0435\u043D\u0442\u0438\u0440\u0443\u0435\u0442\u0435\u0441\u044C \u0432 \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u0445 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u043E\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0441\u0442\u0440\u0430\u0445\u043E\u0432\u0430\u043D\u0438\u044F \u0433\u0440\u0430\u0436\u0434\u0430\u043D \u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u043E\u0439 \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u0438 \u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043C\u043E\u0447\u044C \u043B\u044E\u0434\u044F\u043C \u0432 \u0441\u043B\u043E\u0436\u043D\u044B\u0445 \u0436\u0438\u0437\u043D\u0435\u043D\u043D\u044B\u0445 \u0441\u0438\u0442\u0443\u0430\u0446\u0438\u044F\u0445.</p>',
      button: true,
      buttonText: 'Играть с начала',
      shareButton: { classNames: { mainWraper: 'last__share', linkItem: 'last__share-button' } },
      endingScreen: true,
      specialClass: 'content__step_finish',
      next: '1',
      textAfter: '\n        <div class="text-after">\n          <ul class="text-after__list">\n            <li class="text-after__item">\n              <a href="http://fss.ru" target="_blank" rel="noopener">\n                <span class="text-after__item-text">\u0411\u043E\u043B\u0435\u0435 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E \u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u043D\u0430 fss.ru</span>\n              </a>\n            </li>\n            <li class="text-after__item">\n              <a href="https://www.mk.ru/projects/fss-rf-socialnaya-navigaciya/#experts" target="_blank" rel="noopener">\n                <span class="text-after__item-text">\u041A\u043E\u043B\u043E\u043D\u043A\u0430 \u044D\u043A\u0441\u043F\u0435\u0440\u0442\u043E\u0432</span>\n              </a>\n            </li>\n            <li class="text-after__item">\n              <a href="https://www.mk.ru/projects/fss-rf-socialnaya-navigaciya/#consultation" target="_blank" rel="noopener">\n                <span class="text-after__item-text">\u041E\u043D\u043B\u0430\u0439\u043D \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044F</span>\n              </a>\n            </li>\n            <li class="text-after__item">\n              <a href="https://www.mk.ru/projects/fss-rf-socialnaya-navigaciya/#gosuslugi" target="_blank" rel="noopener">\n                <span class="text-after__item-text">\u041E \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u0443\u0441\u043B\u0443\u0433\u0430\u0445 \u0444\u043E\u043D\u0434\u0430</span>\n              </a>\n            </li>\n          </ul>\n        </div>\n      '
    }
  }
}];

createOrder(GAME_1[0].steps, QUESTIONS_NUMBER, questionsArray);

var jsonAnswerMock1 = JSON.stringify(GAME_1);
// CONCATENATED MODULE: ./components/page/view/abstract-page.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _ref = Object(preact_min["h"])(
  'div',
  null,
  '\u042F \u0432 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0435 \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u0437\u0430\u0434\u0430\u0447\u0438'
);

var AbstractPage = function (_Component) {
  _inherits(AbstractPage, _Component);

  function AbstractPage(props) {
    _classCallCheck(this, AbstractPage);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.progress = _this.props.progress;
    _this._onNext = _this.props.onNext ? _this.props.onNext : function () {};
    return _this;
  }

  AbstractPage.prototype.onNext = function onNext(steps) {
    // window.scrollTo(0, 0);
    'ga' in window && ga('send', 'event', 'SpecialProject-rosatom', 'Rosatom_GoToStep', String(steps));
    this.progress.stepsToStack = steps;
    this.progress.goNext();
    this._onNext(steps);
  };

  AbstractPage.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.screenData.endingScreen) {
      this.progress.startAgain();
    }
  };

  AbstractPage.prototype.render = function render() {
    return _ref;
  };

  AbstractPage.backDataToModel = function backDataToModel(step) {
    var result = {};
    result.type = step.type ? step.type : null;
    result.specialClass = step.specialClass ? 'content__step ' + step.specialClass : 'content__step';
    result.comment = step.comment ? step.comment : null;
    result.title = step.title ? step.title : null;
    result.description = step.description ? step.description : null;
    result.endingScreen = step.endingScreen ? true : null;
    result.audioButtonSelector = step.audioButtonSelector ? step.audioButtonSelector : null;
    result.shareButton = step.shareButton ? step.shareButton : null;
    result.ref = step.ref ? step.ref : null;
    result.imageSrc = step.imageSrc ? step.imageSrc : null;
    result.shareButton = step.shareButton ? step.shareButton : null;

    return result;
  };

  _createClass(AbstractPage, [{
    key: 'screenData',
    get: function get() {
      return this.props.data.steps.get(this.props.progress.current);
    }
  }]);

  return AbstractPage;
}(preact_min["Component"]);


// CONCATENATED MODULE: ./components/page/view/multiple-choice.js


function multiple_choice__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function multiple_choice__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function multiple_choice__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var multiple_choice_MultipleChoice = function (_AbstractPage) {
  multiple_choice__inherits(MultipleChoice, _AbstractPage);

  function MultipleChoice(props) {
    multiple_choice__classCallCheck(this, MultipleChoice);

    var _this = multiple_choice__possibleConstructorReturn(this, _AbstractPage.call(this, props));

    _this.state = { answer: new Set() };
    return _this;
  }

  MultipleChoice.prototype.onCheck = function onCheck(evt, answer) {
    var checked = evt.target.checked;
    var answers = this.state.answer;
    if (checked) {
      answers.add(answer.next);
    } else {
      answers.delete(answer.next);
    }
  };

  MultipleChoice.prototype.render = function render() {
    var _this2 = this;

    var question = this.screenData;
    var mainHeader = this.props.data.title ? Object(preact_min["h"])(
      'h2',
      null,
      this.props.data.title
    ) : '';
    var subHeader = this.props.data.description ? Object(preact_min["h"])(
      'span',
      null,
      this.props.data.description
    ) : '';
    var image = question.imageSrc ? Object(preact_min["h"])(
      'div',
      null,
      Object(preact_min["h"])('img', { src: question.imageSrc, alt: '', style: 'width: 100%' })
    ) : '';
    var imageAuthor = question.imageAuthor ? Object(preact_min["h"])(
      'span',
      null,
      question.imageAuthor
    ) : '';
    var questionTitle = question.title ? Object(preact_min["h"])(
      'h3',
      null,
      question.title
    ) : '';
    var questionDescription = question.description ? Object(preact_min["h"])('div', { dangerouslySetInnerHTML: { __html: question.description } }) : '';
    var listOptions = question.answers.map(function (answer, number) {
      return Object(preact_min["h"])(
        'li',
        null,
        Object(preact_min["h"])(
          'label',
          null,
          Object(preact_min["h"])('input', { type: 'checkbox', checked: _this2.state.answer.has(number),
            onInput: function onInput(evt) {
              return _this2.onCheck(evt, answer);
            } }),
          answer.title
        )
      );
    });
    return Object(preact_min["h"])(
      'article',
      null,
      mainHeader,
      subHeader,
      image,
      imageAuthor,
      Object(preact_min["h"])(
        'form',
        null,
        questionTitle,
        questionDescription,
        Object(preact_min["h"])(
          'ul',
          null,
          listOptions
        ),
        Object(preact_min["h"])(
          'button',
          { type: 'button',
            onClick: function onClick() {
              _this2.onNext(Array.from(_this2.state.answer));
              _this2.state.answer = new Set();
            } },
          '\u041E\u0442\u0432\u0435\u0442\u0438\u0442\u044C'
        )
      )
    );
  };

  MultipleChoice.backDataToModel = function backDataToModel(step) {
    var result = {};
    result.type = step.type ? step.type : null;
    result.isMultiple = false;
    result.imageSrc = step.imageSrc ? step.imageSrc : null;
    result.imageAuthor = step.imageAuthor ? step.imageAuthor : null;
    result.title = step.title ? step.title : null;
    result.description = step.description ? step.description : null;
    result.answers = [];
    for (var _iterator = step.answers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var answer = _ref;

      var resultAnswer = {};
      resultAnswer.title = answer.title ? answer.title : null;
      resultAnswer.next = answer.next ? answer.next : null;
      result.answers.push(resultAnswer);
    }
    return result;
  };

  return MultipleChoice;
}(AbstractPage);


// CONCATENATED MODULE: ./components/picture.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




/*
export default class Picture extends Component {
  constructor(props) {
    super(props);
    // this.source = (this.props.source) ? this.props.source : null;
    this.attributes = (this.props.attributes) ? this.props.attributes : {};
    this.author = (this.props.author) ? this.props.author : null;
    this.className = (this.props.className) ? this.props.className : {};
  }

  componentWillReceiveProps(nextProps) {
    this.attributes = (nextProps.attributes) ? nextProps.attributes : {};
    this.author = (nextProps.author) ? nextProps.author : null;
    this.className = (nextProps.className) ? nextProps.className : {};
  }

  componentWillUnmount(attr1) {
    const image = document.querySelector('.content__photo-wraper img');
    if (image && !image.complete) {
      image.classList.add('content__photo-loading');
    }
    this.attributes = null;
    this.author = null;
    this.className = null;
  }

  render() {
    const picture = (this.attributes.src) ? <div className={(this.className.contentWraper) ? this.className.contentWraper : "content__photo-wraper"}><img onLoad={(evt) => {evt.target.classList.remove('content__photo-loading')}} {...this.attributes}/></div> : null;
    const pictureAuthor = (this.author) ? <div className={(this.className.author) ? this.className.author : "content__photo-legend"}>{this.author}</div> : null;
    return (picture) ? <div className={(this.className.content) ? this.className.content : "content__photo"}>
                      {picture}
                      {pictureAuthor}
                    </div> : null;
  }
}
*/

var picture_Picture = function Picture(props) {
  var attributes = props.attributes ? props.attributes : {};
  var author = props.author ? props.author : null;
  var className = props.className ? props.className : {};

  var picture = attributes.src ? Object(preact_min["h"])(
    'div',
    { className: className.contentWraper ? className.contentWraper : "content__photo-wraper" },
    Object(preact_min["h"])('img', _extends({ onLoad: function onLoad(evt) {
        evt.target.classList.remove('content__photo-loading');
      }, className: 'content__photo-loading' }, attributes))
  ) : null;
  var pictureAuthor = author ? Object(preact_min["h"])(
    'div',
    { className: className.author ? className.author : "content__photo-legend" },
    author
  ) : null;
  return picture ? Object(preact_min["h"])(
    'div',
    { className: className.content ? className.content : "content__photo" },
    picture,
    pictureAuthor
  ) : null;
};

/* harmony default export */ var components_picture = (picture_Picture);
// CONCATENATED MODULE: ./components/page/view/single-choice.js


function single_choice__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function single_choice__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function single_choice__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var single_choice__ref = Object(preact_min["h"])('br', null);

var single_choice__ref2 = Object(preact_min["h"])(
  'span',
  null,
  '\u0423\u0440\u043E\u043A'
);

var _ref3 = Object(preact_min["h"])(
  'h1',
  { 'class': 'title' },
  '\u0422\u0443\u0442\u043E\u0440\u0438\u0430\u043B. \u041E\u043D\u043B\u0430\u0439\u043D-\u0438\u0433\u0440\u0430. \u041F\u043E\u043C\u043E\u0433\u0438 \u0440\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0438\u043C \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C'
);

var _ref4 = Object(preact_min["h"])(
  'h2',
  { className: 'content__question-title' },
  '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0442\u0432\u0435\u0442:'
);

var single_choice_SingleChoice = function (_AbstractPage) {
  single_choice__inherits(SingleChoice, _AbstractPage);

  function SingleChoice(props) {
    single_choice__classCallCheck(this, SingleChoice);

    return single_choice__possibleConstructorReturn(this, _AbstractPage.call(this, props));
  }

  SingleChoice.prototype.render = function render() {
    var _this2 = this;

    var question = this.screenData;
    var subHeader = this.props.data.description ? Object(preact_min["h"])(
      'span',
      null,
      this.props.data.description
    ) : '';
    var questionCounter = this.progress ? Object(preact_min["h"])(
      'h2',
      { 'class': 'question-counter' },
      Object(preact_min["h"])(
        'span',
        { 'class': 'question-counter__title' },
        this.progress.questionNumber,
        '/',
        this.progress.numberOfQuestion,
        single_choice__ref,
        single_choice__ref2
      )
    ) : '';
    var questionTitle = question.title ? Object(preact_min["h"])(
      'h3',
      null,
      question.title
    ) : '';
    var questionDescription = question.description ? Object(preact_min["h"])('div', { className: 'content__main-text', dangerouslySetInnerHTML: { __html: question.description } }) : '';
    var listOptions = question.answers.map(function (answer) {
      return Object(preact_min["h"])(
        'li',
        { className: 'content__question-list-item' },
        Object(preact_min["h"])(
          'button',
          { className: 'content__question-item', type: 'button', onClick: function onClick() {
              return _this2.onNext([answer.next]);
            } },
          answer.title
        )
      );
    });
    return Object(preact_min["h"])(
      'article',
      { className: question.specialClass },
      _ref3,
      subHeader,
      Object(preact_min["h"])(components_picture, { attributes: { src: question.imageSrc, width: 512, height: 386, alt: '' }, author: question.imageAuthor }),
      questionCounter,
      questionTitle,
      questionDescription,
      Object(preact_min["h"])(
        'form',
        { className: 'content__question-form' },
        _ref4,
        Object(preact_min["h"])(
          'ul',
          { className: 'content__question-list' },
          listOptions
        )
      )
    );
  };

  SingleChoice.backDataToModel = function backDataToModel(step) {
    var result = AbstractPage.backDataToModel(step);
    result.isMultiple = false;
    result.answers = [];
    for (var _iterator = step.answers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var answer = _ref5;

      var resultAnswer = {};
      resultAnswer.title = answer.title ? answer.title : null;
      resultAnswer.next = answer.next ? answer.next : null;
      result.answers.push(resultAnswer);
    }
    return result;
  };

  return SingleChoice;
}(AbstractPage);


// CONCATENATED MODULE: ./components/share/settings/constants.js
var VKONTACTE = {
  api: 'http://vk.com/share.php',
  mod: 'vk',
  title: 'ВКонтакте',
  keys: {
    url: 'url',
    title: 'title',
    // description: 'description',
    image: 'image'
  }
};
var FACEBOOK = {
  api: 'http://www.facebook.com/sharer.php',
  mod: 'fb',
  title: 'Facebook',
  keys: {
    url: 'u'
  }
};
var ODNOKLASSNIKI = {
  api: 'https://connect.ok.ru/offer',
  mod: 'ok',
  title: 'Одноклассники',
  // additionalKey: 'st.cmd=addShare&st.s=1',
  keys: {
    url: 'url',
    title: 'title',
    // description: 'st.comments',
    image: 'imageUrl'
  }
};
var TWITTER = {
  api: 'http://twitter.com/share',
  mod: 'tw',
  title: 'Twitter',
  keys: {
    url: 'url',
    title: 'text'
  }

};
var TELEGRAM = {
  api: 'https://telegram.me/share/url',
  mod: 'tm',
  title: 'Telegram',
  keys: {
    url: 'url',
    title: 'text'
  }
};
var WHATSAPP = {
  api: 'https://api.whatsapp.com/send',
  mod: 'wh',
  title: 'WhatsApp',
  keys: {
    messangerText: 'text'
  }
};
var VIBER = {
  api: 'viber://forward',
  mod: 'vb',
  title: 'Viber',
  keys: {
    messangerText: 'text'
  }
};

var SHARE_DEFAULT = [['vk', VKONTACTE], ['fb', FACEBOOK], ['ok', ODNOKLASSNIKI], ['twitter', TWITTER], ['telegram', TELEGRAM], ['whatsapp', WHATSAPP], ['viber', VIBER]];

/*
 vk:
http://vk.com/share.php?
url=https://www.mk.ru/projects/komandirovka-k-maniaku/
title=
description=
image=
 fb:
http://www.facebook.com/sharer.php?
u=https://www.mk.ru/projects/komandirovka-k-maniaku/
 og tags for all other
 ok:
http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1
st._surl=
st.comments=
 tw:
http://twitter.com/share?
url=https://www.mk.ru/projects/komandirovka-k-maniaku/
text=
via=
 wh:
https://api.whatsapp.com/send?
text= + https://www.mk.ru/projects/komandirovka-k-maniaku/ +
tm:
https://telegram.me/share/url?
url=https://www.mk.ru/projects/komandirovka-k-maniaku/
text=
 vb:
viber://forward?
text= + https://www.mk.ru/projects/komandirovka-k-maniaku/ +
*/
// CONCATENATED MODULE: ./components/share/index.js
var share__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



function share__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function share__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function share__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var share__ref2 = Object(preact_min["h"])('div', { 'class': 'header__share-overlay' });

var share__ref3 = Object(preact_min["h"])(
  'h2',
  { 'class': 'header__share-title' },
  '\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F'
);

var share__ref4 = Object(preact_min["h"])(
  'svg',
  { 'class': 'header__button-icon', width: '24', height: '24' },
  Object(preact_min["h"])('use', { xlinkHref: '#svg-share' })
);

var share_ShareComponent = function (_Component) {
  share__inherits(ShareComponent, _Component);

  function ShareComponent(props) {
    share__classCallCheck(this, ShareComponent);

    var _this = share__possibleConstructorReturn(this, _Component.call(this, props));

    _this.share = Object(preact_min["createRef"])();

    _this.onShareClick = function () {
      this.share.current.classList.toggle('header__share_active');
    };

    _this.onShareClick = _this.onShareClick.bind(_this);
    return _this;
  }

  ShareComponent.prototype.getUrl = function getUrl(itemSettings) {
    var _this2 = this;

    if (!itemSettings.api) {
      return null;
    }
    var isFirstKey = true;
    var url = itemSettings.api;
    if ('additionalKey' in itemSettings) {
      url += isFirstKey ? '?' : '&';
      url += itemSettings.additionalKey;
      isFirstKey = false;
    }
    Object.keys(itemSettings.keys).forEach(function (key) {
      if (key in _this2.parameters) {
        url += isFirstKey ? '?' : '&';
        isFirstKey = false;
        url += key === 'title' && !('url' in itemSettings.keys) ? itemSettings.keys[key] + '=' + encodeURIComponent(_this2.parameters[key] + ' ' + _this2.parameters['url']) : itemSettings.keys[key] + '=' + encodeURIComponent(_this2.parameters[key]);
      }
    });
    return url;
  };

  ShareComponent.prototype.renderItem = function renderItem(itemSettings) {
    var _this3 = this;

    if (!itemSettings) {
      return null;
    }
    var icon = itemSettings.mod ? Object(preact_min["h"])('span', { dangerouslySetInnerHTML: { __html: '<svg width="22" height="22"><use xlink:href="#svg-icon-' + itemSettings.mod + '"></use></svg>' } }) : null;
    var listItemClass = '' + (this.classNames.listItem ? this.classNames.listItem : '');
    linkItemClass += '' + (this.classNames.listItem && itemSettings.mod ? this.classNames.listItem + '_' + itemSettings.mod : '');
    var linkItemClass = '' + (this.classNames.linkItem ? this.classNames.linkItem : '');
    linkItemClass += '' + (this.classNames.linkItem && itemSettings.mod ? ' ' + this.classNames.linkItem + '_' + itemSettings.mod : '');
    return Object(preact_min["h"])(
      'li',
      { className: listItemClass ? listItemClass : null },
      Object(preact_min["h"])(
        'a',
        { className: linkItemClass ? linkItemClass : null, onClick: function onClick(evt) {
            evt.preventDefault();
            window.open(_this3.getUrl(itemSettings), '', 'toolbar=0,status=0,width=626,height=436');
          }, href: this.getUrl(itemSettings), target: "_blank", rel: "nofollow noopener", title: itemSettings.title ? itemSettings.title : null },
        icon
      )
    );
  };

  ShareComponent.prototype.render = function render() {
    var _this4 = this;

    var listButtons = Array.from(this.settings, function (_ref) {
      var key = _ref[0],
          value = _ref[1];
      return value;
    }).map(function (item) {
      return _this4.renderItem(item);
    });
    return Object(preact_min["h"])(
      'div',
      { ref: this.share, className: 'header__share' },
      share__ref2,
      Object(preact_min["h"])(
        'div',
        { 'class': 'header__share-body' },
        share__ref3,
        Object(preact_min["h"])(
          'ul',
          { className: this.classNames.mainWraper ? this.classNames.mainWraper : null },
          listButtons
        )
      ),
      Object(preact_min["h"])(
        'button',
        { onClick: this.onShareClick, className: 'header__share-button', 'aria-label': '\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F' },
        share__ref4
      )
    );
  };

  share__createClass(ShareComponent, [{
    key: 'classNames',
    get: function get() {
      if (this._classNames) {
        return this._classNames;
      }
      this._classNames = this.props.classNames ? this.props.classNames : { mainWraper: 'share', listItem: '', linkItem: 'share__button' };
      return this._classNames;
    }
  }, {
    key: 'parameters',
    get: function get() {
      if (this._parameters) {
        return this._parameters;
      }
      if (this.props.parameters) {
        this._parameters = this.props.parameters;
        return this._parameters;
      }
      return {
        url: 'https://www.mk.ru/projects/fss-rf-socialnaya-navigaciya/tutorial',
        messangerText: 'https://www.mk.ru/projects/fss-rf-socialnaya-navigaciya/tutorial',
        title: 'Как рассчитать социальные пособия для граждан РФ'
      };
    }
  }, {
    key: 'settings',
    get: function get() {
      if (this._settings) {
        return this._settings;
      }
      this._settings = new Map(this.props.settings ? this.props.settings : SHARE_DEFAULT);
      return this._settings;
    }
  }]);

  return ShareComponent;
}(preact_min["Component"]);


;
// CONCATENATED MODULE: ./components/page/view/comment.js


function comment__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function comment__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function comment__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var comment__ref = Object(preact_min["h"])('br', null);

var comment__ref2 = Object(preact_min["h"])(
  'span',
  null,
  '\u0423\u0440\u043E\u043A'
);

var comment__ref3 = Object(preact_min["h"])(
  'div',
  { 'class': 'question-counter__winner' },
  Object(preact_min["h"])(
    'span',
    null,
    '6/6'
  ),
  ' ',
  Object(preact_min["h"])('br', null),
  ' \u041F\u043E\u0431\u0435\u0434\u0430!'
);

var comment__ref4 = Object(preact_min["h"])(
  'h2',
  { 'class': 'last__share-title' },
  '\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F:'
);

var comment__ref5 = Object(preact_min["h"])(
  'h1',
  { 'class': 'title' },
  '\u0422\u0443\u0442\u043E\u0440\u0438\u0430\u043B. \u041E\u043D\u043B\u0430\u0439\u043D-\u0438\u0433\u0440\u0430. \u041F\u043E\u043C\u043E\u0433\u0438 \u0440\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0438\u043C \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C'
);

var comment_Comment = function (_AbstractPage) {
  comment__inherits(Comment, _AbstractPage);

  function Comment(props) {
    comment__classCallCheck(this, Comment);

    return comment__possibleConstructorReturn(this, _AbstractPage.call(this, props));
  }

  Comment.prototype.render = function render() {
    var _this2 = this;

    var commentData = this.screenData;
    var buttonText = commentData.buttonText ? commentData.buttonText : 'Ответить';
    var button = commentData.button ? Object(preact_min["h"])(
      'button',
      { className: 'content__progress-button', type: 'button', onClick: function onClick() {
          return _this2.onNext(_this2.screenData.next);
        } },
      Object(preact_min["h"])(
        'span',
        null,
        buttonText
      )
    ) : '';
    var questionCounter = this.progress ? Object(preact_min["h"])(
      'div',
      { className: 'question-counter' },
      !commentData.endingScreen ? Object(preact_min["h"])(
        'span',
        { 'class': 'question-counter__title' },
        this.progress.questionNumber,
        ' / ',
        this.progress.numberOfQuestion,
        comment__ref,
        comment__ref2
      ) : comment__ref3
    ) : '';
    var mainHeader = this.props.data.title ? Object(preact_min["h"])(
      'h1',
      { className: 'content__game-title' },
      this.props.data.title
    ) : '';
    var subHeader = this.props.data.description ? Object(preact_min["h"])(
      'span',
      null,
      this.props.data.description
    ) : '';

    var commentDescription = commentData.description ? Object(preact_min["h"])('div', { className: 'content__description', dangerouslySetInnerHTML: { __html: commentData.description } }) : '';
    var commentAnswers = commentData.answerList ? commentData.answerList.map(function (answer) {
      return answer[1] ? Object(preact_min["h"])(
        'li',
        { className: 'content__answer-item content__answer-item_selected' },
        Object(preact_min["h"])(
          'p',
          { className: 'content__answer' },
          answer[0]
        ),
        commentDescription
      ) : Object(preact_min["h"])(
        'li',
        { className: 'content__answer-item' },
        Object(preact_min["h"])(
          'p',
          { className: 'content__answer' },
          answer[0]
        )
      );
    }) : '';
    var questionDescription = commentData.comment ? Object(preact_min["h"])('div', { className: 'content__main-text', dangerouslySetInnerHTML: { __html: commentData.comment } }) : '';
    var shareButton = commentData.shareButton ? Object(preact_min["h"])(
      'div',
      { 'class': 'last__share-content' },
      comment__ref4,
      Object(preact_min["h"])(share_ShareComponent, commentData.shareButton)
    ) : null;
    var textAfter = commentData.textAfter ? Object(preact_min["h"])('div', { dangerouslySetInnerHTML: { __html: commentData.textAfter } }) : null;

    return Object(preact_min["h"])(
      'article',
      { className: commentData.specialClass },
      comment__ref5,
      mainHeader,
      subHeader,
      Object(preact_min["h"])(components_picture, { attributes: { src: commentData.imageSrc, width: 512, height: 386, alt: '' }, author: commentData.imageAuthor }),
      questionCounter,
      questionDescription,
      Object(preact_min["h"])(
        'ul',
        { className: 'content__answer-list' },
        commentAnswers
      ),
      shareButton,
      button,
      textAfter
    );
  };

  Comment.backDataToModel = function backDataToModel(step) {
    var result = AbstractPage.backDataToModel(step);
    result.button = step.button ? step.button : null;
    result.buttonText = step.buttonText ? step.buttonText : null;
    result.next = step.next ? step.next : null;
    result.textAfter = step.textAfter ? step.textAfter : null;
    result.answerList = step.answerList && step.answerList.length ? step.answerList : null;
    return result;
  };

  return Comment;
}(AbstractPage);


// CONCATENATED MODULE: ./components/page/settings/constants.js





var SELECT_VIEW = [[['type', 'simple-question'], ['isMultiple', true], multiple_choice_MultipleChoice], [['type', 'simple-question'], ['isMultiple', false], single_choice_SingleChoice], [['type', 'simple-question'], single_choice_SingleChoice], [['type', 'comment'], comment_Comment], [AbstractPage]];
// CONCATENATED MODULE: ./components/page/index.js


function page__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function page__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function page__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var page_Page = function (_AbstractPage) {
  page__inherits(Page, _AbstractPage);

  function Page(props) {
    page__classCallCheck(this, Page);

    return page__possibleConstructorReturn(this, _AbstractPage.call(this, props));
  }

  Page.prototype.render = function render() {
    var Page = selectViewFunction(this.screenData, SELECT_VIEW);
    return Object(preact_min["h"])(Page, this.props);
  };

  return Page;
}(AbstractPage);


// CONCATENATED MODULE: ./components/widget/view/abstract-layout.js
var abstract_layout__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function abstract_layout__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function abstract_layout__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function abstract_layout__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var abstract_layout_Layout = function (_Component) {
  abstract_layout__inherits(Layout, _Component);

  function Layout(props) {
    abstract_layout__classCallCheck(this, Layout);

    var _this = abstract_layout__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = { data: _this.props.data, progress: _this.props.progress };
    return _this;
  }

  Layout.prototype.onNext = function onNext() {
    this.setState(this.state.data);
  };

  Layout.prototype.render = function render() {
    var _this2 = this;

    return Object(preact_min["h"])(page_Page, abstract_layout__extends({}, this.state, { onNext: function onNext() {
        return _this2.onNext();
      } }));
  };

  return Layout;
}(preact_min["Component"]);


;
// CONCATENATED MODULE: ./components/widget/settings/constants.js


var constants_SELECT_VIEW = [[['layout', 'compact'], abstract_layout_Layout], [['layout', 'long'], abstract_layout_Layout], [['layout', 'growing'], abstract_layout_Layout], [abstract_layout_Layout]];
// CONCATENATED MODULE: ./components/widget/index.jsx


function widget__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function widget__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function widget__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var widget_WidgetComponent = function (_Component) {
  widget__inherits(WidgetComponent, _Component);

  function WidgetComponent(props) {
    widget__classCallCheck(this, WidgetComponent);

    var _this = widget__possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = { data: _this.props.data, progress: _this.props.progress };
    return _this;
  }

  WidgetComponent.prototype.render = function render() {
    // console.log(`WidgetComponent`);
    var Layout = selectViewFunction({ layout: 'compact' }, constants_SELECT_VIEW);
    return Object(preact_min["h"])(Layout, this.state);
  };

  return WidgetComponent;
}(preact_min["Component"]);


;
// CONCATENATED MODULE: ./model/widget.js
var widget__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function model_widget__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var widget_getStepStructure = function getStepStructure(step) {
  var StepStructure = selectViewFunction(step, SELECT_VIEW);
  return StepStructure.backDataToModel(step);
};

var Widget = function () {
  function Widget(data) {
    model_widget__classCallCheck(this, Widget);

    this.id = 'id' in data ? data.id : 0;
    this.type = 'type' in data ? data.type : 'poll';
    this.title = 'title' in data ? data.title : null;
    this.description = 'description' in data ? data.description : null;
    this.steps = 'steps' in data ? new Map(Object.entries(data.steps).map(function (item) {
      return [item[0], widget_getStepStructure(item[1])];
    })) : {};
    this._start = 'start' in data ? data.start : null;
  }

  widget__createClass(Widget, [{
    key: 'start',
    get: function get() {
      return this._start;
    }
  }]);

  return Widget;
}();


;
// CONCATENATED MODULE: ./moduls/progress.js
var progress__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function progress__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Progress = function () {
  function Progress(start, steps) {
    progress__classCallCheck(this, Progress);

    this._start = start;
    this._answers = new Map();
    this._current = start;
    this._stepsPriority = [];
    this._questionSet = new Set();
    this._pastQuestionSet = new Set();
    if (steps) {
      this.numberOfQuestion = steps;
    }
    this.goNext();
  }

  Progress.prototype.startAgain = function startAgain() {
    this._pastQuestionSet = new Set();
    this._current = this._start;
    this.goNext();
  };

  Progress.prototype.cleanFromDoubled = function cleanFromDoubled() {
    this._stepsPriority = Array.from(new Set(this._stepsPriority));
  };

  Progress.prototype.goNext = function goNext() {
    this._current = this._stepsPriority.length > 0 ? this._stepsPriority.shift() : this._current;
    if (this._questionSet.has(this._current)) {
      this._pastQuestionSet.add(this._current);
    }
  };

  progress__createClass(Progress, [{
    key: 'current',
    get: function get() {
      return this._current;
    }
  }, {
    key: 'stepsToStack',
    set: function set() {
      var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this._stepsPriority = Array.isArray(steps) ? [].concat(steps, this._stepsPriority) : [steps].concat(this._stepsPriority);
    }
  }, {
    key: 'stepsToTail',
    set: function set() {
      var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this._stepsPriority = Array.isArray(steps) ? [].concat(this._stepsPriority, steps) : [].concat(this._stepsPriority, [steps]);
    }
  }, {
    key: 'numberOfQuestion',
    get: function get() {
      return this._questionSet.size;
    },
    set: function set(steps) {
      for (var key in steps) {
        if (steps[key].type === 'simple-question') {
          this._questionSet.add(key);
        }
      }
    }
  }, {
    key: 'questionNumber',
    get: function get() {
      return this._pastQuestionSet.size > 9 ? '' + this._pastQuestionSet.size : '' + this._pastQuestionSet.size;
    }
  }]);

  return Progress;
}();


// CONCATENATED MODULE: ./moduls/loader.jsx


function loader__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var OBJECT_FROM_WINDOW_NAME = 'MKWidgetPolls';
var DEFAULT_WIDGET_PLACE = 'rosatom-game';

/**
 * Набросок разбора структуры виджета.
 * Выделяю отдельные части без ветвлений, для того чтобы в layout-е выводящем всё сразу, можно было выводить часть виджета до ветвления.
 */
// const nextBrunches = function (root, modelData) {
//   console.log(`nextBrunches 789`);
//   const result = []
//   if (modelData.steps.has(root)){
//     if (`next` in modelData.steps.get(root)) {
//       result.push(modelData.steps.get(root).next);
//     }
//     if (`answers` in modelData.steps.get(root)) {
//       modelData.steps.get(root).answers.forEach((element) => {
//         if (`next` in element) {
//           result.push(element.next);
//         }
//       });
//     }
//     const resultSet = new Set(result);
//     resultSet.delete(root);
//     return Array.from(resultSet);
//   }
//   return [];
// };
//
// const toTree = function(modelData, start, ban = []) {
//   console.log(`toTree 789`);
//   const banSet = new Set(ban);
//   const nextBrunchesArray = nextBrunches(start, modelData).map((element) => {
//     if (!banSet.has(element)){
//       return toTree(modelData, element, [...ban, start]);
//     }
//   });
//   const str = (Array.isArray(nextBrunchesArray) && (nextBrunchesArray.length > 1)) ? `[${nextBrunchesArray.join(', ')}]` : nextBrunchesArray[0];
//   return (str) ? `${start} -> ${str}` : `${start}`;
// };

/**********************************************************/

var loader__ref = Object(preact_min["h"])(share_ShareComponent, null);

var loader_Loader = function () {
  function Loader() {
    loader__classCallCheck(this, Loader);
  }

  Loader.start = function start() {
    var responseData = Loader.loadData();
    // console.log(`loader`);
    // console.log(responseData);
    var modelData = new Widget(responseData[0]);
    // console.log(`modelData`);
    // console.log(modelData);
    var progress = new Progress(modelData.start, responseData[0].steps);
    // console.log(`progress`);
    // console.log(progress);

    Object(preact_min["render"])(loader__ref, document.querySelector('.header__share-wrapper'));
    var widgets = OBJECT_FROM_WINDOW_NAME in window ? window.MKWidgetPolls : [];

    for (var _iterator = widgets, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref2 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref2 = _i.value;
      }

      var widget = _ref2;

      // console.log(widgets);
      // console.log(widget);
      var selector = 'place' in widget ? '#' + widget.place : '#' + DEFAULT_WIDGET_PLACE;
      // console.log(selector);
      Object(preact_min["render"])(Object(preact_min["h"])(widget_WidgetComponent, { data: modelData, progress: progress }), document.querySelector(selector));
    }
  };

  Loader.loadData = function loadData() {
    // позже будет реализовано взаимодействие с сервером
    return JSON.parse(jsonAnswerMock1);
  };

  return Loader;
}();


// CONCATENATED MODULE: ./index.js
// import WidgetComponent from './components/widget';

// export default WidgetComponent;



loader_Loader.start();

/***/ }),

/***/ "KM04":
/***/ (function(module, exports) {

!function () {
  var n,
      l,
      u,
      t,
      i,
      o,
      r,
      f,
      e = {},
      c = [],
      s = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function a(n, l) {
    for (var u in l) {
      n[u] = l[u];
    }return n;
  }function h(n) {
    var l = n.parentNode;l && l.removeChild(n);
  }function v(n, l, u) {
    var t,
        i,
        o,
        r = arguments,
        f = {};for (o in l) {
      "key" == o ? t = l[o] : "ref" == o ? i = l[o] : f[o] = l[o];
    }if (arguments.length > 3) for (u = [u], o = 3; o < arguments.length; o++) {
      u.push(r[o]);
    }if (null != u && (f.children = u), "function" == typeof n && null != n.defaultProps) for (o in n.defaultProps) {
      void 0 === f[o] && (f[o] = n.defaultProps[o]);
    }return y(n, f, t, i, null);
  }function y(l, u, t, i, o) {
    var r = { type: l, props: u, key: t, ref: i, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: o };return null == o && (r.__v = r), null != n.vnode && n.vnode(r), r;
  }function p(n) {
    return n.children;
  }function d(n, l) {
    this.props = n, this.context = l;
  }function _(n, l) {
    if (null == l) return n.__ ? _(n.__, n.__.__k.indexOf(n) + 1) : null;for (var u; l < n.__k.length; l++) {
      if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    }return "function" == typeof n.type ? _(n) : null;
  }function m(n) {
    var l, u;if (null != (n = n.__) && null != n.__c) {
      for (n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++) {
        if (null != (u = n.__k[l]) && null != u.__e) {
          n.__e = n.__c.base = u.__e;break;
        }
      }return m(n);
    }
  }function w(l) {
    (!l.__d && (l.__d = !0) && u.push(l) && !k.__r++ || i !== n.debounceRendering) && ((i = n.debounceRendering) || t)(k);
  }function k() {
    for (var n; k.__r = u.length;) {
      n = u.sort(function (n, l) {
        return n.__v.__b - l.__v.__b;
      }), u = [], n.some(function (n) {
        var l, u, t, i, o, r, f;n.__d && (r = (o = (l = n).__v).__e, (f = l.__P) && (u = [], (t = a({}, o)).__v = t, i = N(f, o, t, l.__n, void 0 !== f.ownerSVGElement, null != o.__h ? [r] : null, u, null == r ? _(o) : r, o.__h), T(u, o), i != r && m(o)));
      });
    }
  }function g(n, l, u, t, i, o, r, f, s, a) {
    var v,
        d,
        m,
        w,
        k,
        g,
        x,
        C = t && t.__k || c,
        A = C.length;for (s == e && (s = null != r ? r[0] : A ? _(t, 0) : null), u.__k = [], v = 0; v < l.length; v++) {
      if (null != (w = u.__k[v] = null == (w = l[v]) || "boolean" == typeof w ? null : "string" == typeof w || "number" == typeof w ? y(null, w, null, null, w) : Array.isArray(w) ? y(p, { children: w }, null, null, null) : null != w.__e || null != w.__c ? y(w.type, w.props, w.key, null, w.__v) : w)) {
        if (w.__ = u, w.__b = u.__b + 1, null === (m = C[v]) || m && w.key == m.key && w.type === m.type) C[v] = void 0;else for (d = 0; d < A; d++) {
          if ((m = C[d]) && w.key == m.key && w.type === m.type) {
            C[d] = void 0;break;
          }m = null;
        }k = N(n, w, m = m || e, i, o, r, f, s, a), (d = w.ref) && m.ref != d && (x || (x = []), m.ref && x.push(m.ref, null, w), x.push(d, w.__c || k, w)), null != k ? (null == g && (g = k), s = b(n, w, m, C, r, k, s), a || "option" != u.type ? "function" == typeof u.type && (u.__d = s) : n.value = "") : s && m.__e == s && s.parentNode != n && (s = _(m));
      }
    }if (u.__e = g, null != r && "function" != typeof u.type) for (v = r.length; v--;) {
      null != r[v] && h(r[v]);
    }for (v = A; v--;) {
      null != C[v] && F(C[v], C[v]);
    }if (x) for (v = 0; v < x.length; v++) {
      j(x[v], x[++v], x[++v]);
    }
  }function b(n, l, u, t, i, o, r) {
    var f, e, c;if (void 0 !== l.__d) f = l.__d, l.__d = void 0;else if (i == u || o != r || null == o.parentNode) n: if (null == r || r.parentNode !== n) n.appendChild(o), f = null;else {
      for (e = r, c = 0; (e = e.nextSibling) && c < t.length; c += 2) {
        if (e == o) break n;
      }n.insertBefore(o, r), f = r;
    }return void 0 !== f ? f : o.nextSibling;
  }function x(n, l, u, t, i) {
    var o;for (o in u) {
      "children" === o || "key" === o || o in l || A(n, o, null, u[o], t);
    }for (o in l) {
      i && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || A(n, o, l[o], u[o], t);
    }
  }function C(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || s.test(l) ? u : u + "px";
  }function A(n, l, u, t, i) {
    var o, r, f;if (i && "className" == l && (l = "class"), "style" === l) {
      if ("string" == typeof u) n.style.cssText = u;else {
        if ("string" == typeof t && (n.style.cssText = t = ""), t) for (l in t) {
          u && l in u || C(n.style, l, "");
        }if (u) for (l in u) {
          t && u[l] === t[l] || C(n.style, l, u[l]);
        }
      }
    } else "o" === l[0] && "n" === l[1] ? (o = l !== (l = l.replace(/Capture$/, "")), (r = l.toLowerCase()) in n && (l = r), l = l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, f = o ? E : P, u ? t || n.addEventListener(l, f, o) : n.removeEventListener(l, f, o)) : "list" !== l && "tagName" !== l && "form" !== l && "type" !== l && "size" !== l && "download" !== l && "href" !== l && !i && l in n ? n[l] = null == u ? "" : u : "function" != typeof u && "dangerouslySetInnerHTML" !== l && (l !== (l = l.replace(/xlink:?/, "")) ? null == u || !1 === u ? n.removeAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase()) : n.setAttributeNS("http://www.w3.org/1999/xlink", l.toLowerCase(), u) : null == u || !1 === u && !/^ar/.test(l) ? n.removeAttribute(l) : n.setAttribute(l, u));
  }function P(l) {
    this.l[l.type + !1](n.event ? n.event(l) : l);
  }function E(l) {
    this.l[l.type + !0](n.event ? n.event(l) : l);
  }function z(n, l, u) {
    var t, i;for (t = 0; t < n.__k.length; t++) {
      (i = n.__k[t]) && (i.__ = n, i.__e && ("function" == typeof i.type && i.__k.length > 1 && z(i, l, u), l = b(u, i, i, n.__k, null, i.__e, l), "function" == typeof n.type && (n.__d = l)));
    }
  }function N(l, u, t, i, o, r, f, e, c) {
    var s,
        h,
        v,
        y,
        _,
        m,
        w,
        k,
        b,
        x,
        C,
        A = u.type;if (void 0 !== u.constructor) return null;null != t.__h && (c = t.__h, e = u.__e = t.__e, u.__h = null, r = [e]), (s = n.__b) && s(u);try {
      n: if ("function" == typeof A) {
        if (k = u.props, b = (s = A.contextType) && i[s.__c], x = s ? b ? b.props.value : s.__ : i, t.__c ? w = (h = u.__c = t.__c).__ = h.__E : ("prototype" in A && A.prototype.render ? u.__c = h = new A(k, x) : (u.__c = h = new d(k, x), h.constructor = A, h.render = H), b && b.sub(h), h.props = k, h.state || (h.state = {}), h.context = x, h.__n = i, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != A.getDerivedStateFromProps && (h.__s == h.state && (h.__s = a({}, h.__s)), a(h.__s, A.getDerivedStateFromProps(k, h.__s))), y = h.props, _ = h.state, v) null == A.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);else {
          if (null == A.getDerivedStateFromProps && k !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(k, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(k, h.__s, x) || u.__v === t.__v) {
            h.props = k, h.state = h.__s, u.__v !== t.__v && (h.__d = !1), h.__v = u, u.__e = t.__e, u.__k = t.__k, h.__h.length && f.push(h), z(u, e, l);break n;
          }null != h.componentWillUpdate && h.componentWillUpdate(k, h.__s, x), null != h.componentDidUpdate && h.__h.push(function () {
            h.componentDidUpdate(y, _, m);
          });
        }h.context = x, h.props = k, h.state = h.__s, (s = n.__r) && s(u), h.__d = !1, h.__v = u, h.__P = l, s = h.render(h.props, h.state, h.context), h.state = h.__s, null != h.getChildContext && (i = a(a({}, i), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (m = h.getSnapshotBeforeUpdate(y, _)), C = null != s && s.type == p && null == s.key ? s.props.children : s, g(l, Array.isArray(C) ? C : [C], u, t, i, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), w && (h.__E = h.__ = null), h.__e = !1;
      } else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $(t.__e, u, t, i, o, r, f, c);(s = n.diffed) && s(u);
    } catch (l) {
      u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), n.__e(l, u, t);
    }return u.__e;
  }function T(l, u) {
    n.__c && n.__c(u, l), l.some(function (u) {
      try {
        l = u.__h, u.__h = [], l.some(function (n) {
          n.call(u);
        });
      } catch (l) {
        n.__e(l, u.__v);
      }
    });
  }function $(n, l, u, t, i, o, r, f) {
    var s,
        a,
        h,
        v,
        y,
        p = u.props,
        d = l.props;if (i = "svg" === l.type || i, null != o) for (s = 0; s < o.length; s++) {
      if (null != (a = o[s]) && ((null === l.type ? 3 === a.nodeType : a.localName === l.type) || n == a)) {
        n = a, o[s] = null;break;
      }
    }if (null == n) {
      if (null === l.type) return document.createTextNode(d);n = i ? document.createElementNS("http://www.w3.org/2000/svg", l.type) : document.createElement(l.type, d.is && { is: d.is }), o = null, f = !1;
    }if (null === l.type) p === d || f && n.data === d || (n.data = d);else {
      if (null != o && (o = c.slice.call(n.childNodes)), h = (p = u.props || e).dangerouslySetInnerHTML, v = d.dangerouslySetInnerHTML, !f) {
        if (null != o) for (p = {}, y = 0; y < n.attributes.length; y++) {
          p[n.attributes[y].name] = n.attributes[y].value;
        }(v || h) && (v && (h && v.__html == h.__html || v.__html === n.innerHTML) || (n.innerHTML = v && v.__html || ""));
      }x(n, d, p, i, f), v ? l.__k = [] : (s = l.props.children, g(n, Array.isArray(s) ? s : [s], l, u, t, "foreignObject" !== l.type && i, o, r, e, f)), f || ("value" in d && void 0 !== (s = d.value) && (s !== n.value || "progress" === l.type && !s) && A(n, "value", s, p.value, !1), "checked" in d && void 0 !== (s = d.checked) && s !== n.checked && A(n, "checked", s, p.checked, !1));
    }return n;
  }function j(l, u, t) {
    try {
      "function" == typeof l ? l(u) : l.current = u;
    } catch (l) {
      n.__e(l, t);
    }
  }function F(l, u, t) {
    var i, o, r;if (n.unmount && n.unmount(l), (i = l.ref) && (i.current && i.current !== l.__e || j(i, null, u)), t || "function" == typeof l.type || (t = null != (o = l.__e)), l.__e = l.__d = void 0, null != (i = l.__c)) {
      if (i.componentWillUnmount) try {
        i.componentWillUnmount();
      } catch (l) {
        n.__e(l, u);
      }i.base = i.__P = null;
    }if (i = l.__k) for (r = 0; r < i.length; r++) {
      i[r] && F(i[r], u, t);
    }null != o && h(o);
  }function H(n, l, u) {
    return this.constructor(n, u);
  }function I(l, u, t) {
    var i, r, f;n.__ && n.__(l, u), r = (i = t === o) ? null : t && t.__k || u.__k, l = v(p, null, [l]), f = [], N(u, (i ? u : t || u).__k = l, r || e, e, void 0 !== u.ownerSVGElement, t && !i ? [t] : r ? null : u.childNodes.length ? c.slice.call(u.childNodes) : null, f, t || e, i), T(f, l);
  }n = { __e: function __e(n, l) {
      for (var u, t, i, o = l.__h; l = l.__;) {
        if ((u = l.__c) && !u.__) try {
          if ((t = u.constructor) && null != t.getDerivedStateFromError && (u.setState(t.getDerivedStateFromError(n)), i = u.__d), null != u.componentDidCatch && (u.componentDidCatch(n), i = u.__d), i) return l.__h = o, u.__E = u;
        } catch (l) {
          n = l;
        }
      }throw n;
    } }, l = function l(n) {
    return null != n && void 0 === n.constructor;
  }, d.prototype.setState = function (n, l) {
    var u;u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = a({}, this.state), "function" == typeof n && (n = n(a({}, u), this.props)), n && a(u, n), null != n && this.__v && (l && this.__h.push(l), w(this));
  }, d.prototype.forceUpdate = function (n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), w(this));
  }, d.prototype.render = p, u = [], t = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, k.__r = 0, o = e, r = 0, f = { render: I, hydrate: function hydrate(n, l) {
      I(n, l, o);
    }, createElement: v, h: v, Fragment: p, createRef: function createRef() {
      return { current: null };
    }, isValidElement: l, Component: d, cloneElement: function cloneElement(n, l, u) {
      var t,
          i,
          o,
          r = arguments,
          f = a({}, n.props);for (o in l) {
        "key" == o ? t = l[o] : "ref" == o ? i = l[o] : f[o] = l[o];
      }if (arguments.length > 3) for (u = [u], o = 3; o < arguments.length; o++) {
        u.push(r[o]);
      }return null != u && (f.children = u), y(n.type, f, t || n.key, i || n.ref, null);
    }, createContext: function createContext(n, l) {
      var u = { __c: l = "__cC" + r++, __: n, Consumer: function Consumer(n, l) {
          return n.children(l);
        }, Provider: function Provider(n, u, t) {
          return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function () {
            return t;
          }, this.shouldComponentUpdate = function (n) {
            this.props.value !== n.value && u.some(w);
          }, this.sub = function (n) {
            u.push(n);var l = n.componentWillUnmount;n.componentWillUnmount = function () {
              u.splice(u.indexOf(n), 1), l && l.call(n);
            };
          }), n.children;
        } };return u.Provider.__ = u.Consumer.contextType = u;
    }, toChildArray: function n(l, u) {
      return u = u || [], null == l || "boolean" == typeof l || (Array.isArray(l) ? l.some(function (l) {
        n(l, u);
      }) : u.push(l)), u;
    }, __u: F, options: n }, typeof module < "u" ? module.exports = f : self.preact = f;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// bundle.js